import React, { useState, useRef, useEffect,useMemo } from 'react';
import {
  MessageCircleMore,
  File, TriangleAlert,
  FileText, ChevronUp,
  Edit3,
  X,List,Grid,
  ChevronRight, 
  FileSpreadsheet,
  FileImage,ChevronDown,
  Link,ExternalLink,
  FileVideo,TableOfContents,
  FileAudio,Archive,BringToFront,Shield,
  Files,Home,Send,MessageCircle, Plus, MoreHorizontal, Calendar, User, Flag, CheckCircle, Circle, Clock, AlertCircle, Trash2, Edit2, GripVertical, Filter, Search, Bell, Settings, Download, Upload, Users, Target, BarChart3, TrendingUp, Forward, 
  Eye,EyeOff} from 'lucide-react';
import './digitalsuccessroom.css'
import './digitalsuccessroom2.css'
import './digitalsuccessroom3.css'
import './digitalsuccessroom4.css'
import './digitalsuccessroom5.css'
import { useParams } from 'react-router-dom'
import { Modal, Button, Form } from 'react-bootstrap';
import {AddTaskModal,AddGroupModal,
  EditTaskModal,UpdateGroupModal,
  ShowDescription,ShowShareModal, 
  ShowEditAccessModal,UploadKnowledgebaseModal} 
  from './diff_modals'
import {AddKPIModal,EditKPIModal} from './test_modals'
import toast, { Toaster } from 'react-hot-toast';
import senteventdata from './sentdata_sg_analytics'
import { BeatLoader } from 'react-spinners';
import { motion, AnimatePresence, color } from 'framer-motion';
import AnalyticsComponent from './analytics';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import custom_api_func from './axios_api_func';
import {getCookie,getCsrfToken} from './get_csrfToken'
import LoadingScreen from './loadingscreen';
import RichTextEditor from './richtexteditor';
import EditModal from './editmodal'
import SkeletonWrapper from './skeletonwrapper';

const DigitalSuccessRoom = () => {

  const [activeTab, setActiveTab] = useState('success-plan');
  const [chatOpen, setChatOpen] = useState(false);
  const [loading,setloading] = useState(true)

  const [csrftoken,setcsrftoken] = useState(null)
  async function fetch_csrf_token(){
    await getCsrfToken();
    setcsrftoken(getCookie('csrftoken'))
  }
  useEffect(() => {
    fetch_csrf_token()
  }, []);

  const [username,setusername] = useState(localStorage.getItem('user_name') | 'N/A')
  const [userid,setuserid] = useState(null)
  const [dsrtokenid,setdsrtokenid] = useState(localStorage.getItem('dsrtokenid'))
  
  useEffect(()=>{
    setusername(localStorage.getItem('user_name'))
    custom_api_func.get(`api/get-dsruser-id/${dsrtokenid}`)
      .then((response) => { setuserid(response.data.userid) })
  },[])

  const [taskGroups, setTaskGroups] = useState([]);
  const [settingsGroups, setsettingsGroups] = useState([{ id:'0', title: 'User Permission Management' }]);

  useEffect(()=>{
    if (dsrtokenid){
      get_groups_and_tasks()
      all_dsr_users()
      setgroup_name(taskGroups[0]?.title || '')
    }
  },[])

  const [statuscolumns,setstatuscolumns] = useState({
    'pending':'#d97706','in-progress':'#4338ca','stuck':'#b45309','done':'#15803d','overdue':'#b91c1c'
  })
  const [useraccesslevelcolors,setuseraccesslevelcolors] = useState({
    'view':'#15803d','edit':'#4338ca','internal':'#b45309',
  })
  const [allusersnames,setallusersnames] = useState([''])

  const get_groups_and_tasks = () => {
    setloading(true)
    custom_api_func.get(`api/dsr_get_groups_and_tasks/${dsrtokenid}`)
      .then((response) => {
        setTaskGroups(response.data.TaskGroups)
        setSelectedGroupId(response.data?.TaskGroups[0].id)
        setgroup_name(response.data?.TaskGroups[0].title)
        getalladdtionalfields()
        setloading(false)
      }).catch((error) => { setloading(false) })
  }

  const get_groups_and_tasks2 = () => {
    custom_api_func.get(`api/dsr_get_groups_and_tasks/${dsrtokenid}`)
      .then((response) => { setTaskGroups(response.data.TaskGroups) }).catch((error) => {})
  }

  const [firsttime,setfirsttime] = useState(true)
  useEffect(() => {
    if (taskGroups?.length>1 && firsttime){
      toggleGroup(taskGroups[0].id)
      setfirsttime(false)
    }
  }, [taskGroups?.length]);

  const all_dsr_users = () => {
    custom_api_func.get(`api/dsr_get_users/${dsrtokenid}`)
      .then((response) => { setallusersnames(response.data.users) }).catch((error) => {})
  }

  const getAccessStats = () => {
    const stats = allusersnames.reduce((acc, user) => {
      const level = user.accesslevel?.toLowerCase();
      acc[level] = (acc[level] || 0) + 1;
      return acc;
    }, {});
    return stats;
  };
  const stats = getAccessStats();

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [currentGroup, setCurrentGroup] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [draggedItem, setDraggedItem] = useState(null);
  const [draggedType, setDraggedType] = useState('');
  const [dragOverTarget, setDragOverTarget] = useState(null);

  const handleDragStart = (e, item, type) => {
    setDraggedItem(item); setDraggedType(type);
    e.dataTransfer.effectAllowed = 'move';
    e.currentTarget.classList.add('dragging');
  };
  const handleDragOver = (e) => { e.preventDefault(); e.dataTransfer.dropEffect = 'move'; };
  const handleDragEnter = (e, target) => { e.preventDefault(); setDragOverTarget(target); };
  const handleDragLeave = (e) => { e.preventDefault(); if (!e.currentTarget.contains(e.relatedTarget)) setDragOverTarget(null); };

  async function updateTaskGroupsOrder(groups) {
    const formData = new FormData();
    formData.append('groupsorder', JSON.stringify(groups.map(({ id, order_index }) => ({ id, order_index }))));
    await custom_api_func.post('api/groups_reorder', formData, { headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken } });
  }

  async function updateTasksOrder(tasks) {
    const formData = new FormData();
    formData.append('tasksorder', JSON.stringify(tasks.map(({ id, order_index }) => ({ id, order_index }))))
    await custom_api_func.post('api/tasks_reorder', formData, { headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken } });
  }

  const toggleTaskSpecificFields = (groupId,taskId,field_name,field_value) => {
    var formData_2 = new FormData();
    formData_2.append('taskId', taskId);
    formData_2.append('field_name', field_name);
    formData_2.append('field_value', field_value);
    senteventdata('update_task_specific_fields API Called React-js','')
    setloading(true)
    custom_api_func.post(`api/update_task_specific_fields`,formData_2,{
      headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken },
    }).then((response) => {
      const newGroups = [...taskGroups];
      const group = newGroups.find(g => g.id === groupId);
      const task = group.tasks.find(t => t.id === taskId);
      task[field_name]=field_value
      setTaskGroups(newGroups);
      setloading(false)
    }).catch((error) => {
      setloading(false)
      toast.error("Error Occured with Task Completion. Refresh and try 1 more time. If issue persists please Contact Support");
    })
  };

  const deleteTaskGroup = (groupId) => {
    var formData_2 = new FormData();
    formData_2.append('groupId', groupId);
    senteventdata('deleteTaskGroup API Called React-js','')
    setloading(true)
    custom_api_func.post(`api/delete_dsr_group`,formData_2,{
      headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken },
    }).then((response) => {
      setloading(false)
      setTaskGroups(taskGroups.filter(g => g.id !== groupId));
      toast.success("Group Deleted SuccessFully");
    }).catch((error) => {
      setloading(false)
      toast.error("Error Occured with Group Deleted. Refresh and try 1 more time. If issue persists please Contact Support");
    })
  }

  const deleteTask = (groupId,taskId) => {
    var formData_2 = new FormData();
    formData_2.append('groupId', groupId);
    formData_2.append('taskId', taskId);
    senteventdata('deleteTask API Called React-js','')
    setloading(true)
    custom_api_func.post(`api/delete_dsr_task`,formData_2,{
      headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken },
    }).then((response) => {
      setTaskGroups(prev => prev.map(group => 
        group.id === groupId ? { ...group, tasks: group.tasks.filter(task => task.id !== taskId) } : group
      ));
      setloading(false)
      toast.success("Task Deleted SuccessFully");
    }).catch((error) => {
      setloading(false)
      toast.error("Error Occured with Task Deleted. Refresh and try 1 more time. If issue persists please Contact Support");
    })
  }

  const filteredTaskGroups = taskGroups.filter(group =>
    group.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    group.tasks.some(task => task.title.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const [selectedGroupId, setSelectedGroupId] = useState(taskGroups[0]?.id || 1);
  const [selectedTaskId, setSelectedTaskId] = useState(taskGroups[0]?.tasks[0]?.id || 1);
  const [draggedGroupId, setDraggedGroupId] = useState(null);
  const [dragOverGroupIndex, setDragOverGroupIndex] = useState(null);
  const [draggedTaskId, setDraggedTaskId] = useState(null);
  const [draggedTaskGroupId, setDraggedTaskGroupId] = useState(null);
  const [dragOverTaskId, setDragOverTaskId] = useState(null);

  const handleGroupDragStart = (e, groupId) => {
    setDraggedGroupId(groupId);
    e.dataTransfer.effectAllowed = 'move';
  };
  const handleGroupDragOver = (e, dropIndex) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setDragOverGroupIndex(dropIndex);
  };
  const handleGroupDragLeave = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) setDragOverGroupIndex(null);
  };
  const handleTaskDragStart = (e, taskId, groupId) => {
    setDraggedTaskId(taskId); setDraggedTaskGroupId(groupId);
    e.dataTransfer.effectAllowed = 'move'; e.stopPropagation();
  };
  const handleTaskDragOver = (e, targetTaskId) => {
    e.preventDefault(); e.stopPropagation();
    e.dataTransfer.dropEffect = 'move'; setDragOverTaskId(targetTaskId);
  };
  const handleTaskDragLeave = (e) => {
    e.stopPropagation();
    if (!e.currentTarget.contains(e.relatedTarget)) setDragOverTaskId(null);
  };
  const handleTaskDrop = async (e, targetTaskId, targetGroupId) => {
    e.preventDefault(); e.stopPropagation();
    if (draggedTaskId && draggedTaskGroupId) {
      const sourceGroup = taskGroups.find(g => g.id === draggedTaskGroupId);
      const targetGroup = taskGroups.find(g => g.id === targetGroupId);
      if (sourceGroup && targetGroup) {
        const draggedTaskIndex = sourceGroup.tasks.findIndex(t => t.id === draggedTaskId);
        const targetTaskIndex = targetGroup.tasks.findIndex(t => t.id === targetTaskId);
        if (draggedTaskIndex !== -1) {
          const draggedTask = sourceGroup.tasks[draggedTaskIndex];
          const newTaskGroups = [...taskGroups];
          const sourceGroupIndex = newTaskGroups.findIndex(g => g.id === draggedTaskGroupId);
          newTaskGroups[sourceGroupIndex].tasks.splice(draggedTaskIndex, 1);
          const targetGroupIndex = newTaskGroups.findIndex(g => g.id === targetGroupId);
          const insertIndex = targetTaskIndex !== -1 ? targetTaskIndex : newTaskGroups[targetGroupIndex].tasks.length;
          newTaskGroups[targetGroupIndex].tasks.splice(insertIndex, 0, draggedTask);
          newTaskGroups[sourceGroupIndex].tasks = newTaskGroups[sourceGroupIndex].tasks.map((task, index) => ({ ...task, order_index: index }));
          newTaskGroups[targetGroupIndex].tasks = newTaskGroups[targetGroupIndex].tasks.map((task, index) => ({ ...task, order_index: index }));
          setTaskGroups(newTaskGroups);
          try {
            await updateTasksOrder(newTaskGroups[sourceGroupIndex].tasks);
            if (sourceGroupIndex !== targetGroupIndex) await updateTasksOrder(newTaskGroups[targetGroupIndex].tasks);
          } catch (error) { console.error('Failed to update task order:', error); }
        }
      }
    }
    setDraggedTaskId(null); setDraggedTaskGroupId(null); setDragOverTaskId(null);
  };
  const handleDragEnd = () => {
    setDraggedGroupId(null); setDragOverGroupIndex(null);
    setDraggedTaskId(null); setDraggedTaskGroupId(null); setDragOverTaskId(null);
  };
  const handleGroupDrop = async(e, dropIndex) => {
    e.preventDefault(); e.stopPropagation();
    if (draggedGroupId) {
      const draggedIndex = taskGroups.findIndex(g => g.id === draggedGroupId);
      if (draggedIndex !== -1 && draggedIndex !== dropIndex) {
        const newGroups = [...taskGroups];
        const [draggedGroup] = newGroups.splice(draggedIndex, 1);
        newGroups.splice(dropIndex, 0, draggedGroup);
        const updatedGroups = newGroups.map((group, index) => ({ ...group, order_index: index }));
        setTaskGroups(updatedGroups);
        try { await updateTaskGroupsOrder(updatedGroups); } catch (error) { console.error('Failed to update task group order:', error); }
      }
    }
    setDraggedGroupId(null); setDragOverGroupIndex(null);
  };

  const [newMessage, setNewMessage] = useState('');
  const chatEndRef = useRef(null);
  const [messages, setMessages] = useState([]);

  const getallmessages =()=>{
    setloading(true)
    custom_api_func.get(`api/getalldsrmessages/${dsrtokenid}`)
      .then(response => { setloading(false); setMessages(response.data); })
      .catch(error => { setloading(false); console.log(error); });
  }

  const deletemessage = (id) => {
    setloading(true)
    custom_api_func.get(`api/deletedsrmessages/${id}`)
      .then(response => { setloading(false); setMessages(prev => prev.filter(doc => doc.id !== id)); })
      .catch(error => { setloading(false); console.log(error); });
  };

  const [searchQuerymessages, setSearchQuerymessages] = useState('');
  const [searchTypemessages, setSearchTypemessages] = useState('all');
  const [showSearchmessages, setShowSearchmessages] = useState(false);

  const filteredMessages = useMemo(() => {
    if (!searchQuerymessages.trim()) return messages;
    return messages.filter(message => {
      const query = searchQuerymessages.toLowerCase();
      switch (searchTypemessages) {
        case 'content': return message.content.toLowerCase().includes(query);
        case 'author': return message.author.toLowerCase().includes(query);
        case 'all': default:
          return message.content.toLowerCase().includes(query) || message.author.toLowerCase().includes(query);
      }
    });
  }, [messages, searchQuerymessages, setSearchTypemessages]);

  const highlightTextmessages = (text, query) => {
    if (!query.trim()) return text;
    const regex = new RegExp(`(${query})`, 'gi');
    const parts = text.split(regex);
    return parts.map((part, index) => 
      regex.test(part) ? <mark key={index} style={{ backgroundColor: '#fef08a', padding: '1px 2px', borderRadius: '2px' }}>{part}</mark> : part
    );
  };

  const clearSearchmessages = () => { setSearchQuerymessages(''); setShowSearchmessages(false); };

  const [documents, setDocuments] = useState([]);
  const [filteredDocuments, setFilteredDocuments] = useState([]);
  const [searchDocument, setsearchDocument] = useState('');

  useEffect(() => {
    if (documents.length === 0 || documents.length===null) { setFilteredDocuments([]); }
    else {
      const filtered = documents.filter(doc => {
        const matchesSearch = doc.name.toLowerCase().includes(searchDocument.toLowerCase()) ||
          doc.tags.some(tag => tag.toLowerCase().includes(searchDocument.toLowerCase()));
        return matchesSearch;
      });
      setFilteredDocuments(filtered);
    }
  }, [documents, searchDocument]);

  useEffect(() => {
    if (chatEndRef.current) chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const [mentionQuery, setMentionQuery] = useState('');
  const [cursorPosition, setCursorPosition] = useState(0);
  const chatInputRef = useRef(null);
  const [showUserSuggestions, setShowUserSuggestions] = useState(false);

  const handleChatInputChange = (e) => {
    const value = e.target.value;
    const cursorPos = e.target.selectionStart;
    setChatInput(value);
    const atIndex = value.lastIndexOf('@', cursorPos - 1);
    if (atIndex !== -1 && (atIndex === 0 || value[atIndex - 1] === ' ')) {
      const searchTerm = value.substring(atIndex + 1, cursorPos);
      if (searchTerm.length >= 0) {
        setMentionStart(atIndex); setMentionEnd(cursorPos);
        setShowUserList(true); setCurrentMentionSearch(searchTerm);
      }
    } else {
      setShowUserList(false); setMentionStart(-1); setMentionEnd(-1); setCurrentMentionSearch('');
    }
  };

  const [mentionEnd, setMentionEnd] = useState(-1);

  const selectUser = (idx,user) => {
    const beforeMention = chatInput.substring(0, mentionStart);
    const afterMention = chatInput.substring(mentionEnd);
    const newValue = beforeMention + '@' + user + ' ' + afterMention;
    setChatInput(newValue); setShowUserList(false); setMentionStart(-1); setMentionEnd(-1); setCurrentMentionSearch('');
    settempmentions([...tempmentions,idx])
    setTimeout(() => {
      const newCursorPos = beforeMention.length + user.length + 2;
      chatInputRef.current.setSelectionRange(newCursorPos, newCursorPos);
      chatInputRef.current.focus();
    }, 0);
  };

  const [tempmentions,settempmentions] = useState([])

  const sendMessage = () => {
    setShowUserList(false);
    if (chatInput.trim()) {
      const mentions = tempmentions
      settempmentions([])
      const formData = new FormData();
      formData.append('author',username)
      formData.append('authorid',userid)
      formData.append('content',chatInput)
      formData.append('mentions',mentions.join(', '))
      custom_api_func.post(`api/senddsrmessages/${dsrtokenid}`, formData, {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken }})
        .then(response => {
          getallmessages()
          if(mentions.length>0){
            const formData = new FormData();
            formData.append('author', username);
            formData.append('taggedid', mentions.join(','));
            custom_api_func.post(`api/notifyabouttaggedcomment/${dsrtokenid}`, formData, {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken }})
              .then((response) => {})
          }
        })
        .catch(error => { console.log(error); });
      setChatInput('');
    }
  };

  const handleMessageChange = (e) => {
    const value = e.target.value;
    const position = e.target.selectionStart;
    setNewMessage(value); setCursorPosition(position);
    const textBeforeCursor = value.substring(0, position);
    const lastAtIndex = textBeforeCursor.lastIndexOf('@');
    if (lastAtIndex !== -1) {
      const textAfterAt = textBeforeCursor.substring(lastAtIndex + 1);
      if (!textAfterAt.includes(' ')) { setMentionQuery(textAfterAt); setShowUserSuggestions(true); return; }
    }
    setShowUserSuggestions(false); setMentionQuery('');
  };

  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);

  const getFileIcon = (type) => {
    switch (type.toLowerCase()) {
      case 'pdf': return <FileText color={'#b91c1c'} size={22} />;
      case 'doc': return <FileText color={'#6d28d9'} size={22} />;
      case 'link': return <Link color={'#4b5563'} size={22} />;
      case 'xlsx': case 'xls': case 'csv': case 'spreadsheet': return <FileSpreadsheet color={'#15803d'} size={22} />;
      case 'jpg': case 'jpeg': case 'png': case 'gif': case 'image': return <FileImage color={'#1d4ed8'} size={22} />;
      case 'mp4': case 'avi': case 'mov': case 'video': return <FileVideo color={'#6d28d9'} size={22} />;
      case 'mp3': case 'wav': case 'audio': return <FileAudio color={'#b45309'} size={22} />;
      case 'zip': case 'rar': return <Archive color={'#4b5563'} size={22} />;
      default: return <File color={'#4b5563'} size={22} />;
    }
  };

  const handleDocumentDrag = (e) => {
    e.preventDefault(); e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') setDragActive(true);
    else if (e.type === 'dragleave') setDragActive(false);
  };

  const handleDocumentDrop = (e) => {
    e.preventDefault(); e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) handleFiles(e.dataTransfer.files);
  };

  const getalldocuments =()=>{
    setloading(true)
    custom_api_func.get(`api/getalldsrdocuments/${dsrtokenid}`)
      .then(response => { setloading(false); setDocuments(response.data); })
      .catch(error => { setloading(false); console.log(error); });
  }

  const handleFiles = (files) => {
    Array.from(files).forEach(file => {
      const newDoc = {
        id: Date.now() + Math.random(), name: file.name,
        type: file.type.split('/')[1] || 'unknown',
        uploadDate: new Date().toISOString().split('T')[0],
        uploadedBy: username, uploadedByid: userid, file: file
      };
      const formData = new FormData();
      formData.append('name',file.name)
      formData.append('type',file.type.split('/')[1] || 'unknown')
      formData.append('uploadDate',new Date().toISOString().split('T')[0])
      formData.append('uploadedBy',username)
      formData.append('uploadedByid',userid)
      formData.append('csmplanfiles',file)
      custom_api_func.post(`api/uploaddsrdocuments/${dsrtokenid}`, formData, {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken }})
        .then(response => { toast.success("Upload Successfull"); newDoc.id = response.data['id']; setDocuments(prev => [newDoc, ...prev]); })
        .catch(error => { console.log(error); });
    });
  };

  const downloadDocument = (url) => { window.open('https://api.successguardian.in/media/'+ url, '_blank'); };

  const deleteDocument = (id) => {
    setloading(true)
    custom_api_func.get(`api/deletedsrdocuments/${id}`)
      .then(response => { setloading(false); setDocuments(prev => prev.filter(doc => doc.id !== id)); })
      .catch(error => { setloading(false); console.log(error); });
  };

  const formatMessageContent = (content, mentions = []) => {
    if (!mentions || mentions.length === 0) return content;
    let formattedContent = content;
    mentions.forEach(mention => {
      formattedContent = formattedContent.replaceAll(`@${mention.name}`, `<span class="mention">@${mention.name}</span>`);
    });
    return formattedContent;
  };

  const [chatInput, setChatInput] = useState('');
  const [mentionStart, setMentionStart] = useState(-1);
  const [showUserList, setShowUserList] = useState(false);
  const [currentMentionSearch, setCurrentMentionSearch] = useState('');
  const [addtask,setaddtask] = useState(false)
  const [edittask,setedittask] = useState(false)
  const [task_type,settask_type] = useState("")
  const [task_name,settask_name] = useState("")
  const [task_user,settask_user] = useState("")
  const [task_status,settask_status] = useState("")
  const [task_priority,settask_priority] = useState("")
  const [task_due_date,settask_due_date] = useState("")
  const [task_created_date,settask_created_date] = useState("")
  const [task_note,settask_note] = useState("")
  const [task_id,settask_id] = useState(null)

  const create_task = () => {
    if (task_name.trim()==='') { toast.error("Task Name is a required field"); return; }
    if(task_status.trim()==='') { toast.error("Status is a required field"); return; }
    if(task_priority.trim()==='') { toast.error("Priority is a required field"); return; }
    if(task_due_date.trim()==='') { toast.error("Due Date is a required field"); return; }
    if(task_user.trim()==='') { toast.error("Assigned to is a required field"); return; }
    var formData_2 = new FormData();
    formData_2.append('name', task_name); formData_2.append('status', task_status);
    formData_2.append('priority', task_priority); formData_2.append('description', task_note);
    formData_2.append('due_date', task_due_date); formData_2.append('task_user', task_user);
    formData_2.append('groupId', selectedGroupId);
    formData_2.append('addtional_fields', JSON.stringify(alladdtionalfieldsvalues));
    setloading(true);
    senteventdata('add_dsr_task API Called React-js','')
    custom_api_func.post(`api/add_dsr_task/${dsrtokenid}`,formData_2,{
      headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken },
    }).then((response) => {
      setaddtask(false); setloading(false); get_groups_and_tasks2(); toast.success("Task Created SuccessFully");
    }).catch((error) => { setloading(false); toast.error("Error Occured with Task Creation."); })
  }

  const [addgroup,setaddgroup] = useState("")
  const [group_name,setgroup_name] = useState("")

  const create_group = () => {
    if (group_name.trim()==='') { toast.error("Group Name is a required field"); return; }
    var formData_2 = new FormData();
    formData_2.append('group_name', group_name);
    setaddgroup(false); setloading(true);
    senteventdata('create_group API Called React-js','')
    custom_api_func.post(`api/add_dsr_group/${dsrtokenid}`,formData_2,{
      headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken },
    }).then((response) => {
      setaddgroup(false); setloading(false); get_groups_and_tasks2(); toast.success("Group Created SuccessFully");
    }).catch((error) => { setloading(false); toast.error("Error Occured with Group Creation."); })
  }

  const [updategroup,setupdategroup] = useState("")
  const update_group = (group_name,selectedGroupId) => {
    if (group_name.trim()==='') { toast.error("Group Name is a required field"); return; }
    var formData_2 = new FormData();
    formData_2.append('group_name', group_name); formData_2.append('groupId', selectedGroupId);
    setupdategroup(false);
    senteventdata('edit_dsr_group API Called React-js','')
    custom_api_func.post(`api/edit_dsr_group`,formData_2,{
      headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken },
    }).then((response) => { setupdategroup(false); }).catch((error) => {
      toast.error("Error Occured with Group Name. Refresh and try 1 more time.");
    })
  }

  const get_expanded_view2 = (taskid) => {
    custom_api_func.get(`api/dsr_get_expanded_view/${taskid}`).then((response) => {
      settask_note(response.data.description)
    }).catch((error) => {})
  }

  const [showActionsDropdown, setShowActionsDropdown] = useState(false);
  const [showsavetemplate,setshowsavetemplate] = useState(false);
  const [title,setTitle] = useState("")

  const saveastemplate = () => {
    if (title.trim()==='') { toast.error("Title is a required field"); return; }
    var formData_2 = new FormData();
    formData_2.append('title',title);
    setloading(true); setshowsavetemplate(false);
    senteventdata('saveastemplate API Called React-js','')
    custom_api_func.post(`api/saveastemplate/${dsrtokenid}`,formData_2,{
      headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken },
    }).then((response) => {
      setshowsavetemplate(false); setloading(false); toast.success("Template Saved SuccessFully");
    }).catch((error) => { setloading(false); toast.error(`Error: ${error}`); })
  }

  const [showoverridetemplate,setshowoverridetemplate] = useState(false);
  const [alltemplates,setalltemplates] = useState([])
  const [templateid,settemplateid] = useState("")

  const overridewithtemplate = () => {
    var formData_2 = new FormData();
    formData_2.append('templateid',templateid);
    senteventdata('overridewithtemplate API Called React-js','')
    custom_api_func.post(`api/overridewithtemplate/${dsrtokenid}`,formData_2,{
      headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken },
    }).then((response) => {
      setshowoverridetemplate(false); toast.success("Template Override SuccessFully"); setloading(true); get_groups_and_tasks();
    }).catch((error) => { toast.error(`Error: ${error}`); })
  }

  const getcsplantemplates = () => {
    custom_api_func.get(`api/getcsplantemplates`).then((response) => {
      setalltemplates(response.data.alltemplates); setshowoverridetemplate(true);
    }).catch(error => { toast.error(`Error: ${error}`); })
  }

  const [showuploadcsvcsplan,setshowuploadcsvcsplan] = useState(false);
  const [data_file, setdata_file] = useState('');
  const [columnNames, setColumnNames] = useState([]);
  const [columnMapping, setcolumnMapping] = useState([]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (fileExtension === 'csv') {
        Papa.parse(file, {
          header: true,
          complete: (result) => {
            const parsedData = result.data;
            if (!parsedData || parsedData.length === 0) { toast.error('Empty or invalid CSV file.'); return; }
            setColumnNames(Object.keys(parsedData[0])); setdata_file(parsedData);
          },
          error: (error) => { toast.error('Error parsing CSV.'); },
        });
      } else if (['xls', 'xlsx', 'numbers'].includes(fileExtension)) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const parsedData = XLSX.utils.sheet_to_json(worksheet);
          if (!parsedData || parsedData.length === 0) { toast.error('Empty or invalid Excel file.'); return; }
          setColumnNames(Object.keys(parsedData[0])); setdata_file(parsedData);
        };
        reader.onerror = (error) => { toast.error('Error reading Excel file.'); };
        reader.readAsArrayBuffer(file);
      } else { toast.error('Invalid file type.'); }
    } else { toast.error('No file selected.'); }
  };

  const handleMappingChange = (columnName, attributeName) => {
    setcolumnMapping({ ...columnMapping, [columnName]: attributeName });
  };

  const handleFileSave = () => {
    const formData = new FormData();
    formData.append('file',JSON.stringify(data_file))
    formData.append('columnMapping',JSON.stringify(columnMapping))
    custom_api_func.post(`api/dsrcsvupload/${dsrtokenid}`, formData, {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken }})
      .then(response => { toast.success("Upload Successfull"); setshowuploadcsvcsplan(false); window.location.reload(false); })
      .catch(error => { console.log(error); });
  }

  const [availablecolumns,setavailablecolumns] = useState([
    { "val": "Status", "type": "dropdown-column", "options": [{"color":"#00c875","title":"Done"},{"color":"#fdab3d","title":"In Progress"},{"color":"#e2445c","title":"Stuck"},{"color":"#c4c4c4","title":"Not Started Yet"}] },
    { "val": "Person", "type": "member-column" },
    { "val": "Date", "type": "date-column" },
    { "val": "Priority", "type": "dropdown-column", "options": [{"color":"#ffcb00","title":"Low"},{"color":"#a25ddc","title":"Medium"},{"color":"#e2445c","title":"High"},{"color":"#c4c4c4","title":"Not Assigned"}] },
    { "val": "Last Updated", "type": "time-column" }
  ])

  const chatMessagesRef = useRef(null);
  const [isLoadingOlderMessages, setIsLoadingOlderMessages] = useState(false);

  useEffect(() => {
    if (chatMessagesRef.current && !isLoadingOlderMessages) {
      chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    if (isLoadingOlderMessages && chatMessagesRef.current) {
      const scrollContainer = chatMessagesRef.current;
      const savedScrollHeight = scrollContainer.scrollHeight;
      const adjustScroll = () => {
        if (scrollContainer.scrollHeight > savedScrollHeight) {
          const heightDifference = scrollContainer.scrollHeight - savedScrollHeight;
          scrollContainer.scrollTop = heightDifference; setIsLoadingOlderMessages(false);
        } else { requestAnimationFrame(adjustScroll); }
      };
      requestAnimationFrame(adjustScroll);
    }
  }, [messages, isLoadingOlderMessages]);

  const [showLoadMore, setShowLoadMore] = useState(false);

  const handleScroll = () => {
    if (chatMessagesRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = chatMessagesRef.current;
      const isScrollable = scrollHeight > clientHeight;
      const isNearTop = scrollTop < 50;
      const shouldShow = messages.length > 0 && (!isScrollable || isNearTop);
      setShowLoadMore(shouldShow);
    }
  };

  useEffect(() => { handleScroll(); }, [messages]);

  const [timingint,settimingint] = useState(1)

  const loadMoreMessages = () => {
    if (!chatMessagesRef.current) return;
    setIsLoadingOlderMessages(true);
    custom_api_func.get(`api/getalldsrmessagesloadmore/${dsrtokenid}/${timingint}`)
      .then(response => {
        setMessages(prevMessages => [...response.data, ...prevMessages]);
        setShowLoadMore(false); settimingint(prev => prev + 1);
        toast.success("More Messages Loaded.")
      })
      .catch(error => { console.log(error); setShowLoadMore(true); setIsLoadingOlderMessages(false); });
  };

  const [formData, setFormData] = useState({
    blockName: '', chartType: '', attribute_id: '', groupby_id: '', customer_id: '',
    attribute_agg:'', attribute_timeline:'', attribute_timeline_agg:'', chartColor: '#000000'
  });

  const [ShowAddKPIForm,setShowAddKPIForm] = useState(false)
  const [ShowEditKPIForm,setShowEditKPIForm] = useState(false)
  const [attributes, setattributes] = useState([]);
  const [group_attributes, setgroup_attributes] = useState([]);

  const fetchDSRlist = () => {
    custom_api_func.get(`api/get_dsr_list`).then((response) => {
      setattributes(response.data['attributes']); setgroup_attributes(response.data['group_attributes']);
    }).catch((error) => { console.error('Error fetching segments:', error); });
  }

  const addChart = (newElement) => { setblocks(prev => [...prev, newElement]); }

  const Add_KPI = () => {
    var formData_2 = new FormData();
    setloading(true)
    formData_2.append('blockName', formData.blockName); formData_2.append('chartType', formData.chartType);
    formData_2.append('attribute_id', formData.attribute_id); formData_2.append('groupby_id', formData.groupby_id);
    formData_2.append('attribute_agg', formData.attribute_agg); formData_2.append('attribute_timeline', formData.attribute_timeline);
    formData_2.append('attribute_timeline_agg', formData.attribute_timeline_agg); formData_2.append('chartColor', formData.chartColor);
    formData_2.append('object_index', blocks.length+1);
    formData_2.append('x', (window.innerWidth / 2) - (400 / 2)); formData_2.append('y', (window.innerHeight / 2) - (300 / 2));
    custom_api_func.post(`api/add_dsr_chart/${dsrtokenid}`,formData_2,{ headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken } })
      .then((response) => { addChart(response.data.blocks); setShowAddKPIForm(false); setloading(false); toast.success("KPI Created SuccessFully"); })
      .catch((error) => { setloading(false); toast.error("Error Occured."); });
  }

  const [blocks, setblocks] = useState([]);

  const editChart = (newElement) => { setblocks(prev => prev.map(el => el.id === object_id ? { ...el, ...newElement } : el)); }

  const Edit_KPI = () => {
    var formData_2 = new FormData();
    setloading(true)
    formData_2.append('blockName', formData.blockName); formData_2.append('chartType', formData.chartType);
    formData_2.append('attribute_id', formData.attribute_id); formData_2.append('groupby_id', formData.groupby_id);
    formData_2.append('attribute_agg', formData.attribute_agg); formData_2.append('attribute_timeline', formData.attribute_timeline);
    formData_2.append('attribute_timeline_agg', formData.attribute_timeline_agg); formData_2.append('chartColor', formData.chartColor);
    custom_api_func.post(`api/edit_dsr_chart/${object_id}`,formData_2,{ headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken } })
      .then((response) => { editChart(response.data.blocks); setShowEditKPIForm(false); setloading(false); toast.success("Update SuccessFully"); })
      .catch((error) => { setloading(false); toast.error("Error Occured."); });
  }

  const delete_KPI = (chart_id) =>{
    setloading(true)
    custom_api_func.get(`api/delete_dsr_chart/${chart_id}`).then((response) => {
      setblocks(prev => prev.filter(el => el.id !== chart_id)); setloading(false); toast.success('KPI Deleted Successfully')
    }).catch((error) => { setloading(false); toast.error("Error Occured ",error); });
  }

  const [object_id,setobject_id]= useState(null);
  const get_chart = (chart_id) => {
    setloading(true)
    custom_api_func.get(`api/get_dsr_chart/${chart_id}`).then((response) => {
      formData.blockName = response.data.data.blockName; formData.chartType = response.data.data.chartType;
      formData.attribute_id = response.data.data.attribute_id; formData.groupby_id = response.data.data.groupby_id;
      formData.attribute_agg = response.data.data.attribute_agg; formData.attribute_timeline = response.data.data.attribute_timeline;
      formData.attribute_timeline_agg = response.data.data.attribute_timeline_agg; formData.chartColor = response.data.data.chartColor;
      setShowEditKPIForm(true); setloading(false); setobject_id(chart_id);
    }).catch((error) => { setloading(false); toast.error("Error Occured ",error); });
  }

  useEffect(()=>{
    if (activeTab === 'analytics' && dsrtokenid) fetch_analytics()
  },[activeTab])

  const fetch_analytics = () => {
    senteventdata('fetch_analytics API Called React-js','')
    setloading(true)
    custom_api_func.get(`api/fetch_analytics/${dsrtokenid}`).then((response) => {
      if (response.data.blocks?.length>0) { setblocks(response.data.blocks); setloading(false); }
      else { setblocks([]); setloading(false); }
    }).catch((error) => { toast.error('Error fetching Analytics'); setblocks([]); setloading(false); });
  }

  const handle_KPI_edit = (chart_id) => { get_chart(chart_id); }

  const updateBlockPosition = (block_id, x, y, width, height) => {
    var formData_2 = new FormData();
    formData_2.append('width', width); formData_2.append('height', height);
    formData_2.append('x', x); formData_2.append('y', y);
    setloading(true)
    custom_api_func.post(`api/update_dsr_chart/${block_id}`,formData_2,{ headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken } })
      .then((response) => { setloading(false); })
      .catch((error) => { setloading(false); toast.error("Error Occured with last Update."); });
  };

  const [opendrownanalytics,setopendrownanalytics] = useState(false)
  const [editingblocks, seteditingblocks] = useState(false);

  const handletoast=()=> {
    if (editingblocks) toast.success('Editing Mode Turned Off');
    else toast.success('Editing Mode Turned On');
  }

  const revokeaccess=(userid)=> {
    setloading(true)
    custom_api_func.get(`api/dsr_revokeaccess/${userid}`)
      .then((response) => { setallusersnames(allusersnames.filter(g => g.id !== userid)); toast.success("Access Revoked SuccessFully"); setloading(false); })
      .catch((error) => { setloading(false); })
  }

  const [shareshow,setshareshow] = useState(false)
  const [shareusername,setshareusername] = useState("")
  const [shareemailid,setshareemailid] = useState("")
  const [shareuserid,setshareuserid] = useState(false)
  const [shareuseraccess,setshareuseraccess] = useState("")

  const grant_access=()=> {
    var formData_2 = new FormData();
    setloading(true)
    formData_2.append('name', shareusername); formData_2.append('email', shareemailid); formData_2.append('accesslevel', shareuseraccess);
    custom_api_func.post(`api/grant_access/${dsrtokenid}`,formData_2,{ headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken } })
      .then((response) => { setshareshow(false); setloading(false); toast.success('Access Granted'); })
      .catch((error) => { setloading(false); })
  }

  const [showeditaccess,setshoweditaccess] = useState(false)
  const [selectededitaccessuser,setselectededitaccessuser] = useState(null)

  const edit_access=()=> {
    var formData_2 = new FormData();
    setloading(true)
    formData_2.append('id', shareuserid); formData_2.append('name', shareusername);
    formData_2.append('email', shareemailid); formData_2.append('accesslevel', shareuseraccess);
    custom_api_func.post(`api/update_grant_access`,formData_2,{ headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken } })
      .then((response) => { setshoweditaccess(false); setloading(false); toast.success('Access Granted'); })
      .catch((error) => { setloading(false); })
  }

  const ShareLink = () => {
    const canUseClipboardAPI = navigator.clipboard && window.isSecureContext;
    var formdata_x = new FormData();
    formdata_x.append('dsrtokenid', dsrtokenid);
    setloading(true);
    custom_api_func.post(`api/get_dsr_share_token2/`, formdata_x, { headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken } })
      .then((response) => {
        const successplanUrl = `https://digitalsuccessroom.successguardian.in/digitalsuccessroominviteduniv/${response.data.dsr_share_token}`;
        const fallbackCopy = (text) => {
          try {
            const textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.position = "fixed"; textArea.style.left = "0"; textArea.style.top = "0";
            textArea.style.width = "1px"; textArea.style.height = "1px"; textArea.style.padding = "0";
            textArea.style.border = "none"; textArea.style.outline = "none";
            textArea.style.boxShadow = "none"; textArea.style.background = "transparent";
            textArea.setAttribute('readonly', '');
            document.body.appendChild(textArea);
            if (navigator.userAgent.match(/ipad|iphone/i)) {
              textArea.contentEditable = true; textArea.readOnly = false;
              const range = document.createRange(); range.selectNodeContents(textArea);
              const selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range);
              textArea.setSelectionRange(0, 999999);
            } else { textArea.select(); }
            const successful = document.execCommand("copy");
            document.body.removeChild(textArea);
            return successful;
          } catch (err) { console.error('Fallback copy failed:', err); return false; }
        };
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari || !canUseClipboardAPI) {
          const success = fallbackCopy(successplanUrl);
          if (success) { toast.success("Link Copied to Clipboard"); }
          else {
            toast.custom((t) => {
              const handleCopy = () => { navigator.clipboard.writeText(successplanUrl); toast.success('Link copied!'); };
              return (
                <div style={{ maxWidth:'500px',width:'100%',background:'#fff',boxShadow:'0 4px 6px rgba(0,0,0,0.1)',borderRadius:'10px',display:'flex',overflow:'hidden',border:'1px solid #ddd',fontFamily:'Arial,sans-serif',opacity:t.visible?1:0,transform:t.visible?'translateY(0)':'translateY(-20px)',transition:'all 0.3s ease' }}>
                  <div style={{ flex:1,padding:'16px' }}>
                    <p style={{ margin:0,fontWeight:'bold',fontSize:'14px' }}>Copy this link:</p>
                    <div style={{ marginTop:'8px',padding:'8px',background:'#f5f5f5',borderRadius:'6px',fontSize:'13px',wordBreak:'break-all',display:'flex',alignItems:'center',justifyContent:'space-between' }}>
                      <span style={{ maxWidth:'295px' }}>{successplanUrl}</span>
                      <button onClick={handleCopy} style={{ marginLeft:'8px',padding:'4px 8px',fontSize:'12px',cursor:'pointer',borderRadius:'4px',border:'1px solid #4338ca',background:'#4338ca',color:'#fff' }}>Copy</button>
                    </div>
                  </div>
                  <div style={{ borderLeft:'1px solid #eee',display:'flex' }}>
                    <button onClick={() => toast.dismiss(t.id)} style={{ padding:'0 16px',border:'none',background:'none',cursor:'pointer',color:'#4338ca',fontWeight:'bold' }}>Close</button>
                  </div>
                </div>
              );
            });
          }
          setshareshow(false); setloading(false);
        } else {
          navigator.clipboard.writeText(successplanUrl)
            .then(() => { toast.success("Link Copied to Clipboard"); setshareshow(false); setloading(false); })
            .catch((err) => {
              const success = fallbackCopy(successplanUrl);
              if (success) { toast.success("Link Copied to Clipboard"); }
              else {
                toast.custom((t) => {
                  const handleCopy = () => { navigator.clipboard.writeText(successplanUrl); toast.success('Link copied!'); };
                  return (
                    <div style={{ maxWidth:'400px',width:'100%',background:'#fff',boxShadow:'0 4px 6px rgba(0,0,0,0.1)',borderRadius:'10px',display:'flex',overflow:'hidden',border:'1px solid #ddd',fontFamily:'Arial,sans-serif',opacity:t.visible?1:0,transform:t.visible?'translateY(0)':'translateY(-20px)',transition:'all 0.3s ease' }}>
                      <div style={{ flex:1,padding:'16px' }}>
                        <p style={{ margin:0,fontWeight:'bold',fontSize:'14px' }}>Copy this link:</p>
                        <div style={{ marginTop:'8px',padding:'8px',background:'#f5f5f5',borderRadius:'6px',fontSize:'13px',wordBreak:'break-all',display:'flex',alignItems:'center',justifyContent:'space-between' }}>
                          <span>{successplanUrl}</span>
                          <button onClick={handleCopy} style={{ marginLeft:'8px',padding:'4px 8px',fontSize:'12px',cursor:'pointer',borderRadius:'4px',border:'1px solid #4338ca',background:'#4338ca',color:'#fff' }}>Copy</button>
                        </div>
                      </div>
                      <div style={{ borderLeft:'1px solid #eee',display:'flex' }}>
                        <button onClick={() => toast.dismiss(t.id)} style={{ padding:'0 16px',border:'none',background:'none',cursor:'pointer',color:'#4338ca',fontWeight:'bold' }}>Close</button>
                      </div>
                    </div>
                  );
                });
              }
              setshareshow(false); setloading(false);
            });
        }
      }).catch(error => { setloading(false); toast.error(`Failed to generate share link: ${error}`); });
  };

  const [allknowledgebase,setknowledgebase] = useState([])

  const getallknowledgebase = () => {
    setloading(true)
    custom_api_func.get(`api/getdsrallknowledgebase/${dsrtokenid}`)
      .then(response => { setknowledgebase(response.data); setloading(false); })
      .catch(error => { console.log(error); setloading(false); });
  }

  const [allavailablekbtags,setallavailablekbtags] = useState([
    {'id':'0','key':'0','value':'A'},{'id':'1','key':'1','value':'B'},{'id':'2','key':'2','value':'C'}
  ])

  const getallavailablekbtags = () => {
    custom_api_func.get(`api/getallavailablekbtags/${dsrtokenid}`)
      .then(response => { setallavailablekbtags(response.data); })
      .catch(error => { console.log(error); });
  }

  const deleteknowledgebaseresource = (uid) => {
    custom_api_func.get(`api/deletedsrknowledgebase/${uid}`)
    setloading(true)
      .then(response => { setknowledgebase(prev => prev.filter(doc => doc.id !== uid)); setloading(false); })
      .catch(error => { console.log(error); setloading(false); });
  }

  const [showkb,setshowkb] = useState(false)
  const [kbfilename,setkbfilename] = useState('')
  const [kbdescription,setkbdescription] = useState('')
  const [kbtags,setkbtags] = useState('')
  const [kburl,seturl] = useState('')
  const [kbfiles,setkbfiles] = useState(null)
  const kbfileInputRef = useRef(null);

  const uploaddsrknowledgebaseresource=()=>{
    Array.from(kbfiles).forEach(file => {
      const newDoc = {
        id: Date.now() + Math.random(), title: kbfilename!=='' ? kbfilename : file.name,
        type: file.type.split('/')[1] || 'unknown', description:kbdescription, url:'',
        tags:kbtags.map(tag => tag.value), dateAdded:new Date().toISOString().split('T')[0], file: file
      };
      const formData = new FormData();
      formData.append('name',kbfilename!=='' ? kbfilename : file.name)
      formData.append('type',file.type.split('/')[1] || 'unknown')
      formData.append('description',kbdescription); formData.append('url',kburl)
      formData.append('tags',kbtags.map(tag => tag.value))
      formData.append('dateAdded',new Date().toISOString().split('T')[0])
      formData.append('dsrknowledgebasefiles',file)
      setloading(true)
      custom_api_func.post(`api/uploaddsrknowledgebase/${dsrtokenid}`, formData, {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken }})
        .then(response => {
          toast.success("Upload Successfull"); newDoc.id = response.data['id']; newDoc.url = response.data['url'];
          setknowledgebase(prev => [newDoc, ...prev]); setshowkb(false); setloading(false);
        }).catch(error => { console.log(error); setloading(false); });
    });
  }

  const uploaddsrknowledgebaseresourcelink=()=>{
    const newDoc = {
      id: Date.now() + Math.random(), title: kbfilename, type: 'link', description:kbdescription,
      url:kburl, tags:kbtags.map(tag => tag.value), dateAdded:new Date().toISOString().split('T')[0],
    };
    const formData = new FormData();
    formData.append('name',kbfilename); formData.append('type','link');
    formData.append('description',kbdescription); formData.append('url',kburl);
    formData.append('tags',kbtags.map(tag => tag.value))
    formData.append('dateAdded',new Date().toISOString().split('T')[0])
    setloading(true)
    custom_api_func.post(`api/uploaddsrknowledgebase2/${dsrtokenid}`, formData, {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken }})
      .then(response => {
        toast.success("Upload Successfull"); newDoc.id = response.data['id'];
        setknowledgebase(prev => [newDoc, ...prev]); setshowkb(false); setloading(false);
      }).catch(error => { setloading(false); console.log(error); });
  }

  const [searchknowledgebase,setsearchknowledgebase] = useState('')
  const allTags = [...new Set(allknowledgebase.flatMap(item => item.tags))];
  const [selectedTags, setSelectedTags] = useState([]);

  const getTypeColor = (type) => {
    const colors = { pdf:'#b91c1c', video:'#b45309', image:'#15803d', sheet:'#0e7490', doc:'#6d28d9', link:'#4338ca' };
    return colors[type] || '#4b5563';
  };

  const filteredknowledgebase = useMemo(() => {
    let filtered = allknowledgebase;
    if (searchknowledgebase) {
      filtered = filtered.filter(item =>
        item.title.toLowerCase().includes(searchknowledgebase.toLowerCase()) ||
        item.description.toLowerCase().includes(searchknowledgebase.toLowerCase()) ||
        item.tags.some(tag => tag.toLowerCase().includes(searchknowledgebase.toLowerCase()))
      );
    }
    if (selectedTags.length > 0) {
      filtered = filtered.filter(item => selectedTags.some(tag => item.tags.includes(tag)));
    }
    filtered.sort((a, b) => new Date(b.dateAdded) - new Date(a.dateAdded));
    return filtered;
  }, [allknowledgebase,searchknowledgebase, selectedTags]);

  const [showFilters,setShowFilters] = useState(false)

  const toggleTag = (tag) => {
    setSelectedTags(prev => prev.includes(tag) ? prev.filter(t => t !== tag) : [...prev, tag]);
  };

  const [alladdtionalfields,setalladdtionalfields]= useState([])

  const getalladdtionalfields = () => {
    custom_api_func.get(`api/getalladdtionalfields/${dsrtokenid}`)
      .then(response => { setalladdtionalfields(response.data); })
      .catch(error => { console.log(error); });
  }

  const deleteaddtionalfield = (selected_field_id) => {
    var formData_2 = new FormData();
    setloading(true)
    senteventdata('deleteaddtionalfield API Called React-js','')
    custom_api_func.get(`api/deleteaddtionalfield/${selected_field_id}`,formData_2)
      .then(response => { setloading(false); get_groups_and_tasks2(); })
      .catch(error => { setloading(false); console.log(error); });
  }

  const [showeaddddtionalfield,setshowaddaddtionalfield] = useState(false)
  const [showeditaddtionalfield,setshoweditaddtionalfield] = useState(false)
  const [field_name,setfield_name] = useState('')
  const [field_type,setfield_type] = useState('text')
  const [field_options,setfield_options] = useState([])
  const [field_selected_group,setfield_selected_group] = useState('all')

  const add_addtionalfield = (groupId,fieldName, fieldType, fieldOptions) => {
    var formData_2 = new FormData();
    formData_2.append('field_name', fieldName); formData_2.append('field_type', fieldType);
    formData_2.append('options', fieldOptions); formData_2.append('selected_group', groupId);
    senteventdata('add_addtionalfield API Called React-js','')
    setloading(true)
    custom_api_func.post(`api/add_addtionalfield/${dsrtokenid}`,formData_2, {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken }})
      .then(response => { get_groups_and_tasks2(); setshowaddaddtionalfield(false); setloading(false); })
      .catch(error => { setloading(false); console.log(error); });
  }

  const [selected_field_id,setselected_field_id] = useState(null)

  const update_addtionalfield = () => {
    var formData_2 = new FormData();
    formData_2.append('field_name', field_name); formData_2.append('field_type', field_type);
    formData_2.append('options', field_options); formData_2.append('selected_group', field_selected_group);
    senteventdata('update_addtionalfield API Called React-js','')
    setloading(true)
    custom_api_func.post(`api/update_addtionalfield/${selected_field_id}`,formData_2, {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken }})
      .then(response => { getalladdtionalfields(); setloading(false); setshoweditaddtionalfield(false); })
      .catch(error => { setloading(false); console.log(error); });
  }

  const [alladdtionalfieldsvalues,setalladdtionalfieldsvalues] = useState([])

  const get_additional_all_field_values = (taskid) => {
    custom_api_func.get(`api/get_additional_field_values/${dsrtokenid}/${taskid}`)
      .then(response => { setalladdtionalfieldsvalues(response.data); })
      .catch(error => { console.log(error); });
  }

  const [viewMode, setViewMode] = useState('list');
  const [editingStep, setEditingStep] = useState(null);
  const [editingGroup, setEditingGroup] = useState(null);
  const [showActivityTypes, setShowActivityTypes] = useState(false);
  const [expandedDocs, setExpandedDocs] = useState(new Set());
  const dragRef = useRef(null);
  const [expandedGroups, setExpandedGroups] = useState(new Set([1, 2]));
  const [managingFieldsForGroup, setManagingFieldsForGroup] = useState(null);
  const [newFieldName, setNewFieldName] = useState('');
  const [newFieldType, setNewFieldType] = useState('text');
  const [newFieldOptions, setNewFieldOptions] = useState('');
  const typeOptions = ['Task', 'Milestone', 'Review', 'Approval'];
  const fieldTypes = [
    { value: 'text', label: 'Text' }, { value: 'date', label: 'Date' },
    { value: 'single_choice', label: 'Single Choice' }, { value: 'multiple_choice', label: 'Multiple Choice' }
  ];
  const [availableSteps, setavailableSteps] = useState([]);
  const statusOptions = ['pending', 'in-progress', 'done', 'overdue'];

  const getStatusColor = (status) => {
    const colors = {
      'pending': { backgroundColor: '#fef3c7', color: '#92400e' },
      'in-progress': { backgroundColor: '#e0e7ff', color: '#3730a3' },
      'done': { backgroundColor: '#dcfce7', color: '#15803d' },
      'overdue': { backgroundColor: '#fee2e2', color: '#b91c1c' }
    };
    return colors[status] || colors.pending;
  };

  const isTaskLocked = (task, groupId) => {
    if (!task.dependencies || task.dependencies.length === 0) return false;
    const allTasks = taskGroups.flatMap(group => group.tasks);
    return task.dependencies.some(depId => {
      const depTask = allTasks.find(t => t.id === depId);
      return !depTask || depTask.status !== 'done';
    });
  };

  const toggleGroup = (groupId) => {
    setExpandedGroups(prev => {
      const newSet = new Set(prev);
      if (newSet.has(groupId)) newSet.delete(groupId); else newSet.add(groupId);
      return newSet;
    });
  };

  const toggleDocumentation = (taskId) => {
    setExpandedDocs(prev => {
      const newSet = new Set(prev);
      if (newSet.has(taskId)) newSet.delete(taskId); else newSet.add(taskId);
      return newSet;
    });
  };

  const updateStep = (groupId, taskId, updates) => {
    setloading(true)
    var formData_2 = new FormData();
    formData_2.append('groupId', groupId);
    formData_2.append('name', editingStep.step.title);
    formData_2.append('status', editingStep.step.status);
    formData_2.append('documentation', editingStep.step.documentation);
    formData_2.append('due_date', editingStep.step.due_date);
    formData_2.append('task_user', editingStep.step.task_user);
    formData_2.append('taskId', taskId);
    formData_2.append('updates', JSON.stringify(updates));
    senteventdata('edit_dsr_task API Called React-js','')
    custom_api_func.post(`api/edit_dsr_task`,formData_2,{ headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken } })
      .then((response) => {
        setTaskGroups(prev => prev.map(group => 
          group.id === groupId 
            ? { ...group, tasks: group.tasks.map(task => task.id === taskId ? { ...task, ...updates, id:response.data.id } : task) }
            : group
        ));
        setEditingStep(null); setloading(false)
      }).catch((error) => { setloading(false); toast.error("Error Occured with Update."); })
  };

  const [addstepid, setaddstepid] = useState(null)

  const addStep = (groupId) => {
    const group = taskGroups.find(g => g.id === groupId);
    const groupAdditionalFields = group?.additional_fields || [];
    const newTask = {
      id: Date.now(), title: 'New Task', status: 'pending', priority: 'medium', assignee: 1,
      dueDate: new Date().toISOString().split('T')[0], createdDate: new Date().toISOString().split('T')[0],
      description: '', waitDays: 0, type: 'Task', sharedInPortal: false,
      emailTemplate: 'Default Template', dependencies: [], documentation: '',
      additional_fields: groupAdditionalFields.reduce((acc, field) => {
        acc[field.name] = field.type === 'multiple_choice' ? [] : ''; return acc;
      }, {})
    };
    setavailableSteps(taskGroups.flatMap(group =>
      group.tasks.filter(s => s.id !== newTask.id).map(s => ({ ...s, groupId: group.id }))
    ));
    setEditingStep({ step: newTask, groupId: group.id })
    setaddstepid(newTask.id)
    setTaskGroups(prev => prev.map(group => group.id === groupId ? { ...group, tasks: [...group.tasks, newTask] } : group));
  };

  const renderFieldInput = (group, task, field) => {
    const currentValue = task.additional_fields?.[field.name] || (field.type === 'multiple_choice' ? [] : '');
    return currentValue ? (
      <div style={{ width:'100%', maxWidth:'120px', padding:'4px 8px', border:'1px solid #d1d5db', borderRadius:'4px', fontSize:'12px', backgroundColor:'#f9fafb' }}>
        {currentValue}
      </div>
    ) : null;
  };

  const renderFieldEditInput = (field, value, onChange) => {
    const inputBase = { width:'100%', padding:'8px 12px', border:'1.5px solid #9ca3af', borderRadius:'8px', fontSize:'14px', fontFamily:'Inter,system-ui,sans-serif', outline:'none', transition:'border-color 0.15s, box-shadow 0.15s', color:'#111827', backgroundColor:'#fff' };
    switch (field.type) {
      case 'text':
        return (
          <input type="text" value={value || ''} onChange={(e) => onChange(e.target.value)} style={inputBase}
            placeholder={`Enter ${field.name}`}
            onFocus={(e) => { e.target.style.borderColor='#4338ca'; e.target.style.outline='2px solid #4338ca'; e.target.style.outlineOffset='2px'; }}
            onBlur={(e) => { e.target.style.borderColor='#9ca3af'; e.target.style.outline='none'; }} />
        );
      case 'date':
        return (
          <input type="date" value={value || ''} onChange={(e) => onChange(e.target.value)} style={inputBase}
            onFocus={(e) => { e.target.style.borderColor='#4338ca'; e.target.style.outline='2px solid #4338ca'; e.target.style.outlineOffset='2px'; }}
            onBlur={(e) => { e.target.style.borderColor='#9ca3af'; e.target.style.outline='none'; }} />
        );
      case 'single_choice':
        return (
          <select value={value || ''} onChange={(e) => onChange(e.target.value)}
            style={{ ...inputBase, WebkitAppearance:'none', MozAppearance:'none', appearance:'none', backgroundImage:"url(\"data:image/svg+xml;utf8,<svg fill='none' stroke='%234b5563' stroke-width='2' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'/></svg>\")", backgroundRepeat:'no-repeat', backgroundPosition:'right 12px center', backgroundSize:'16px', cursor:'pointer' }}
            onFocus={(e) => { e.target.style.borderColor='#4338ca'; e.target.style.outline='2px solid #4338ca'; e.target.style.outlineOffset='2px'; }}
            onBlur={(e) => { e.target.style.borderColor='#9ca3af'; e.target.style.outline='none'; }}
          >
            <option value="">Select an option...</option>
            {field.options?.map(option => <option key={option} value={option}>{option}</option>)}
          </select>
        );
      case 'multiple_choice':
        return (
          <div style={{ position:'relative' }}>
            <button type="button" aria-haspopup="listbox" aria-expanded={false}
              style={{ width:'100%', border:'1.5px solid #9ca3af', borderRadius:'8px', backgroundColor:'#fff', minHeight:'42px', padding:'8px 36px 8px 12px', cursor:'pointer', transition:'all 0.15s', display:'flex', alignItems:'center', position:'relative', fontSize:'14px', color:'#374151', textAlign:'left', outline:'none' }}
              onClick={(e) => {
                const dropdown = e.currentTarget.nextElementSibling;
                const isVisible = dropdown.style.display === 'block';
                document.querySelectorAll('.edit-multiselect-dropdown').forEach(d => { d.style.display = 'none'; });
                dropdown.style.display = isVisible ? 'none' : 'block';
                e.currentTarget.setAttribute('aria-expanded', !isVisible);
                if (!isVisible) { e.currentTarget.style.borderColor='#4338ca'; e.currentTarget.style.outline='2px solid #4338ca'; e.currentTarget.style.outlineOffset='2px'; }
                else { e.currentTarget.style.borderColor='#9ca3af'; e.currentTarget.style.outline='none'; }
              }}
              onMouseEnter={(e) => { if (e.currentTarget.getAttribute('aria-expanded') !== 'true') e.currentTarget.style.borderColor='#4b5563'; }}
              onMouseLeave={(e) => { if (e.currentTarget.getAttribute('aria-expanded') !== 'true') e.currentTarget.style.borderColor='#9ca3af'; }}
            >
              <div style={{ display:'flex', flexWrap:'wrap', gap:'4px', flex:1 }}>
                {Array.isArray(value) && value.length > 0 ? value.map(v => (
                  <span key={v} style={{ backgroundColor:'#e0e7ff', color:'#3730a3', padding:'2px 8px', borderRadius:'6px', fontSize:'12px', fontWeight:'600', border:'1px solid #c7d2fe' }}>{v}</span>
                )) : <span style={{ color:'#4b5563' }}>Select options...</span>}
              </div>
              <svg style={{ position:'absolute', right:'12px', top:'50%', transform:'translateY(-50%)', pointerEvents:'none', color:'#4b5563' }} width="16" height="16" viewBox="0 0 20 20" fill="none">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M6 8l4 4 4-4"/>
              </svg>
            </button>
            <div className="edit-multiselect-dropdown" role="listbox" aria-multiselectable="true"
              style={{ display:'none', position:'absolute', top:'100%', left:0, right:0, backgroundColor:'#fff', border:'1px solid #d1d5db', borderRadius:'8px', boxShadow:'0 8px 24px rgba(0,0,0,0.12)', zIndex:1000, maxHeight:'220px', overflowY:'auto', marginTop:'4px' }}
              onClick={(e) => e.stopPropagation()}>
              <div style={{ padding:'8px 12px', borderBottom:'1px solid #f1f5f9', display:'flex', gap:'12px', backgroundColor:'#f9fafb' }}>
                <button type="button" onClick={(e) => { e.stopPropagation(); onChange([...field.options]); }} style={{ background:'none', border:'none', color:'#4338ca', fontSize:'12px', fontWeight:'600', cursor:'pointer', padding:'4px 8px', borderRadius:'4px' }}>Select All</button>
                <button type="button" onClick={(e) => { e.stopPropagation(); onChange([]); }} style={{ background:'none', border:'none', color:'#b91c1c', fontSize:'12px', fontWeight:'600', cursor:'pointer', padding:'4px 8px', borderRadius:'4px' }}>Clear All</button>
              </div>
              {field.options?.map((option) => {
                const isSelected = Array.isArray(value) && value.includes(option);
                return (
                  <label key={option} style={{ display:'flex', alignItems:'center', gap:'10px', padding:'10px 14px', fontSize:'13px', cursor:'pointer', backgroundColor:isSelected?'#e0e7ff':'transparent', color:isSelected?'#3730a3':'#374151', borderBottom:'1px solid #f3f4f6', fontWeight:isSelected?'600':'500', userSelect:'none' }}>
                    <div style={{ width:'16px', height:'16px', border:isSelected?'2px solid #4338ca':'2px solid #9ca3af', borderRadius:'4px', backgroundColor:isSelected?'#4338ca':'transparent', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                      {isSelected && <svg width="10" height="10" viewBox="0 0 16 16" fill="none"><path stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 4L6 11l-3-3"/></svg>}
                    </div>
                    <input type="checkbox" checked={isSelected} onChange={(e) => { e.stopPropagation(); const newValue = isSelected ? value.filter(v => v !== option) : [...(Array.isArray(value)?value:[]), option]; onChange(newValue); }} style={{ position:'absolute', opacity:0, cursor:'pointer', width:'16px', height:'16px' }} />
                    {option}
                  </label>
                );
              })}
            </div>
          </div>
        );
      default:
        return <input type="text" value={value || ''} onChange={(e) => onChange(e.target.value)} style={inputBase} placeholder={`Enter ${field.name}`} />;
    }
  };

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.compact-multiselect-dropdown') && !e.target.closest('button[aria-haspopup="listbox"]')) {
      document.querySelectorAll('.compact-multiselect-dropdown, .edit-multiselect-dropdown').forEach(dropdown => {
        dropdown.style.display = 'none';
        const trigger = dropdown.previousElementSibling;
        if (trigger) { trigger.setAttribute('aria-expanded', 'false'); trigger.style.borderColor = '#9ca3af'; trigger.style.outline = 'none'; }
      });
    }
  });

  const getDependencyNames = (task, allTaskGroups) => {
    const allTasks = allTaskGroups.flatMap(group => group.tasks);
    return task.dependencies.map(depId => allTasks.find(t => t.id === depId)?.title).filter(Boolean);
  };

  const addFieldToGroup = (groupId, fieldName, fieldType, fieldOptions) => {
    if (!fieldName.trim()) return;
    setNewFieldName(''); setNewFieldType('text'); setNewFieldOptions('');
    add_addtionalfield(groupId,fieldName, fieldType, fieldOptions)
  };

  // ─────────── TABS CONFIG ───────────
  const tabs = [
    { id:'success-plan', label:'Success Plan', icon:Home, onClick:() => { setSelectedGroupId(taskGroups[0]?.id); setgroup_name(taskGroups[0]?.title); getalladdtionalfields(); setActiveTab('success-plan'); } },
    { id:'analytics', label:'Analytics', icon:TrendingUp, onClick:() => { fetch_analytics(); fetchDSRlist(); setActiveTab('analytics'); } },
    { id:'documents', label:'Documents', icon:Files, onClick:() => { getalldocuments(); setActiveTab('documents'); } },
    { id:'knowledge-base', label:'Knowledge Base', icon:BringToFront, onClick:() => { getallknowledgebase(); setActiveTab('knowledge-base'); } },
    { id:'updates', label:'Updates', icon:MessageCircleMore, onClick:() => { getallmessages(); setActiveTab('updates'); } },
    { id:'settings', label:'Settings', icon:Settings, onClick:() => { setSelectedGroupId('0'); setgroup_name('User Permission Management'); setActiveTab('settings'); } },
  ];

  // ─────────────────── STYLE TOKENS ───────────────────
  const T = {
    accent: '#4338ca',
    accent2: '#6d28d9',
    tableHeaderAccent: '#3730a3',
    bg: '#f3f4f6',
    border: '#d1d5db',
    borderMed: '#9ca3af',
    textPrimary: '#111827',
    textSecondary: '#1f2937',
    textMuted: '#4b5563',
    white: '#ffffff',
  };

  const btnPrimary = {
    display:'flex', alignItems:'center', gap:'5px',
    padding:'0 14px', height:'32px', fontSize:'13px', fontWeight:'650',
    backgroundColor:T.accent, color:T.white, border:'none', borderRadius:'8px',
    cursor:'pointer', boxShadow:'0 2px 8px rgba(67,56,202,0.40)',
    transition:'all 0.15s', fontFamily:'Inter,system-ui,sans-serif',
  };
  const btnPrimaryHover = { backgroundColor:T.tableHeaderAccent, transform:'translateY(-1px)', boxShadow:'0 4px 12px rgba(67,56,202,0.45)' };

  const btnSecondary = {
    display:'flex', alignItems:'center', gap:'5px',
    padding:'0 14px', height:'32px', fontSize:'13px', fontWeight:'500',
    backgroundColor:T.white, color:'#374151', border:`1.5px solid ${T.borderMed}`,
    borderRadius:'8px', cursor:'pointer', transition:'all 0.15s', fontFamily:'Inter,system-ui,sans-serif',
  };

  const btnDestructive = {
    display:'flex', alignItems:'center', gap:'4px',
    padding:'0 10px', height:'28px', fontSize:'12px', fontWeight:'600',
    backgroundColor:'transparent', color:'#b91c1c', border:'1.5px solid #fca5a5',
    borderRadius:'6px', cursor:'pointer', transition:'all 0.15s', fontFamily:'Inter,system-ui,sans-serif',
  };

  // Total tasks / progress
  const totalTasks = taskGroups.reduce((sum, group) => sum + group.tasks.length, 0);
  const completedTasks = taskGroups.reduce((sum, group) => sum + group.tasks.filter(t => t.status === 'done').length, 0);
  const overallProgress = totalTasks ? Math.round((completedTasks / totalTasks) * 100) : 0;
  const activeGroups = taskGroups.filter(group => group.tasks.some(t => t.status !== 'done')).length;

  return (
    <>
      <style>{`
        *, *::before, *::after { box-sizing: border-box; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }
        :root { color-scheme: light; }
        @keyframes slideUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
        @keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
        ::-webkit-scrollbar { width:4px; height:4px; }
        ::-webkit-scrollbar-track { background:transparent; }
        ::-webkit-scrollbar-thumb { background:#d1d5db; border-radius:4px; }
        * { scrollbar-width: thin; scrollbar-color: #d1d5db transparent; }
        .dsr-tab:hover { background:#eef2ff !important; color:#4338ca !important; }
        .dsr-tab-active { color:#3730a3 !important; font-weight:700 !important; background:#e0e7ff !important; border-radius:7px !important; }
        .dsr-nav-item:hover { background:#eef2ff !important; color:#4338ca !important; }
        .dsr-nav-item.active { background:#e0e7ff !important; color:#3730a3 !important; font-weight:650 !important; }
        .dsr-table-row:hover { background:#f5f3ff !important; }
        .dsr-card:hover { box-shadow:0 4px 24px rgba(0,0,0,0.10) !important; border-color:#c7d2fe !important; }
        .dsr-btn-primary:hover { background:#3730a3 !important; transform:translateY(-1px); box-shadow:0 4px 12px rgba(67,56,202,0.45) !important; }
        .dsr-btn-secondary:hover { border-color:#4338ca !important; color:#4338ca !important; }
        .dsr-btn-destructive:hover { background:#fee2e2 !important; }
        .dsr-dropdown-item:hover { background:#eef2ff !important; color:#4338ca !important; }
        .dsr-dropdown-item-danger:hover { background:#fee2e2 !important; color:#b91c1c !important; }
        .dsr-input:focus { border-color:#4338ca !important; outline:2px solid #4338ca !important; outline-offset:2px !important; }
        .mention { background:#e0e7ff; color:#4338ca; border-radius:4px; padding:1px 5px; font-weight:600; }
      `}</style>
      <Toaster />

     <SkeletonWrapper
              loading={loading}
              showProgress={true}
              showIcon={true}
              icon="https://api.successguardian.in/media/logo_sg_small.png"
              accentColor="#6366f1"
              staggerDelay={60}
            >
        <div style={{ fontFamily:"'Inter', system-ui, sans-serif", backgroundColor:T.bg, minHeight:'100vh', display:'flex', flexDirection:'column', zoom:'95%', colorInterpolation:'sRGB', WebkitFontSmoothing:'antialiased', MozOsxFontSmoothing:'grayscale', animation:'fadeIn 0.4s ease' }}>

          {/* ── STICKY TOP NAV BAR ── */}
          <header style={{ backgroundColor:T.white, borderBottom:`1px solid ${T.border}`, padding:'0 24px', height:'54px', display:'flex', justifyContent:'space-between', alignItems:'center', position:'sticky', top:0, zIndex:100 }}>
            <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
              <div style={{ background:'linear-gradient(135deg,#4338ca,#6d28d9)', width:'29px', height:'29px', borderRadius:'8px', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                <Target size={16} color="white" />
              </div>
              <span style={{ fontSize:'15px', fontWeight:'700', color:T.textPrimary, letterSpacing:'-0.3px' }}>Digital Success Room</span>
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
              <button
                className="dsr-btn-primary"
                onClick={() => setshareshow(true)}
                style={btnPrimary}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#3730a3'; e.currentTarget.style.transform='translateY(-1px)'; e.currentTarget.style.boxShadow='0 4px 12px rgba(67,56,202,0.45)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor=T.accent; e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow='0 2px 8px rgba(67,56,202,0.40)'; }}
              >
                <Forward size={14} />
                Share
              </button>
            </div>
          </header>


          {/* ── TWO-COLUMN LAYOUT ── */}
          <div style={{ display:'flex', flex:1, minHeight:0 }}>

            {/* ── LEFT SIDEBAR ── */}
            <div style={{ width:'205px', flexShrink:0, backgroundColor:T.white, borderRight:`1px solid ${T.border}`, display:'flex', flexDirection:'column', padding:'12px 10px 16px 10px' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'0 4px 8px 4px', marginBottom:'4px', borderBottom:`1px solid ${T.border}` }}>
                <span style={{ fontSize:'10px', fontWeight:'600', color:T.textMuted, textTransform:'uppercase', letterSpacing:'0.08em' }}>Navigation</span>
              </div>
              <nav style={{ display:'flex', flexDirection:'column', gap:'2px', flex:1 }}>
                {tabs.map((tab) => {
                  const Icon = tab.icon;
                  const isActive = activeTab === tab.id;
                  return (
                    <button
                      key={tab.id}
                      className={`dsr-nav-item${isActive?' active':''}`}
                      onClick={tab.onClick}
                      style={{ display:'flex', alignItems:'center', gap:'8px', width:'100%', padding:'8px 10px', borderRadius:'7px', border:'none', cursor:'pointer', fontSize:'13px', fontWeight: isActive?'650':'500', color: isActive?T.tableHeaderAccent:T.textSecondary, backgroundColor: isActive?'#e0e7ff':'transparent', textAlign:'left', transition:'all 0.15s', fontFamily:"'Inter',system-ui,sans-serif" }}
                    >
                      <Icon size={15} />
                      {tab.label}
                    </button>
                  );
                })}
              </nav>
            </div>

            {/* ── MAIN CONTENT ── */}
            <div style={{ flex:1, minWidth:0, display:'flex', flexDirection:'column' }}>

              {/* Board header strip */}
              <div style={{ padding:'16px 22px', backgroundColor:T.white, borderBottom:`1px solid ${T.border}`, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div>
                  <h1 style={{ fontSize:'18px', fontWeight:'780', letterSpacing:'-0.5px', color:T.textPrimary, margin:0, lineHeight:'1.2' }}>
                    {tabs.find(t => t.id === activeTab)?.label}
                  </h1>
                  <p style={{ margin:0, fontSize:'12px', color:T.textMuted, marginTop:'2px' }}>
                    {activeTab === 'success-plan' && 'Manage tasks, groups, and progress'}
                    {activeTab === 'analytics' && 'Track KPIs and overall progress'}
                    {activeTab === 'documents' && 'Upload and manage shared files'}
                    {activeTab === 'knowledge-base' && 'Curated resources and references'}
                    {activeTab === 'updates' && 'Team messages and mentions'}
                    {activeTab === 'settings' && 'User permissions and access control'}
                  </p>
                </div>

                {/* Per-tab action buttons */}
                {activeTab === 'success-plan' && (
                  <div style={{ position:'relative' }}>
                    <button
                      className="dsr-btn-primary"
                      style={btnPrimary}
                      onClick={() => setShowActionsDropdown(!showActionsDropdown)}
                      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#3730a3'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor=T.accent; }}
                    >
                      Actions <ChevronDown size={13} />
                    </button>
                    {showActionsDropdown && (
                      <div onMouseLeave={() => setShowActionsDropdown(false)}
                        style={{ position:'absolute', top:'calc(100% + 6px)', right:0, backgroundColor:T.white, border:`1px solid ${T.border}`, borderRadius:'10px', minWidth:'180px', zIndex:1000, padding:'5px', boxShadow:'0 8px 24px rgba(0,0,0,0.12)' }}>
                        {[
                          { label:'Add Group', action:() => { setaddgroup(true); setShowActionsDropdown(false); } },
                          { label:'Save as Template', action:() => { setshowsavetemplate(true); setShowActionsDropdown(false); } },
                          { label:'Load from Template', action:() => { getcsplantemplates(); setShowActionsDropdown(false); } },
                        ].map((item, i) => (
                          <button key={i} className="dsr-dropdown-item"
                            style={{ width:'100%', padding:'7px 9px', fontSize:'12px', borderRadius:'6px', color:'#374151', background:'transparent', border:'none', cursor:'pointer', textAlign:'left', fontFamily:"'Inter',system-ui,sans-serif", fontWeight:'500', display:'block' }}
                            onClick={item.action}>
                            {item.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {activeTab === 'analytics' && (
                  <div style={{ position:'relative' }}>
                    <button className="dsr-btn-primary" style={btnPrimary}
                      onClick={() => setopendrownanalytics(!opendrownanalytics)}
                      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#3730a3'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor=T.accent; }}>
                      Actions <ChevronDown size={13} />
                    </button>
                    {opendrownanalytics && (
                      <div onMouseLeave={() => setopendrownanalytics(false)}
                        style={{ position:'absolute', top:'calc(100% + 6px)', right:0, backgroundColor:T.white, border:`1px solid ${T.border}`, borderRadius:'10px', minWidth:'200px', zIndex:1000, padding:'5px', boxShadow:'0 8px 24px rgba(0,0,0,0.12)' }}>
                        <button className="dsr-dropdown-item"
                          style={{ width:'100%', padding:'7px 9px', fontSize:'12px', borderRadius:'6px', color:'#374151', background:'transparent', border:'none', cursor:'pointer', textAlign:'left', display:'flex', alignItems:'center', gap:'7px', fontFamily:"'Inter',system-ui,sans-serif", fontWeight:'500' }}
                          onClick={() => { setShowAddKPIForm(true); setopendrownanalytics(false); }}>
                          <Plus size={13} /> Add a KPI
                        </button>
                        <button className="dsr-dropdown-item"
                          style={{ width:'100%', padding:'7px 9px', fontSize:'12px', borderRadius:'6px', color:'#374151', background:'transparent', border:'none', cursor:'pointer', textAlign:'left', display:'flex', alignItems:'center', gap:'7px', fontFamily:"'Inter',system-ui,sans-serif", fontWeight:'500' }}
                          onClick={() => { seteditingblocks(!editingblocks); handletoast(); setopendrownanalytics(false); }}>
                          {editingblocks ? <EyeOff size={13} /> : <Eye size={13} />}
                          {editingblocks ? 'Turn Editing Off' : 'Turn Editing On'}
                        </button>
                      </div>
                    )}
                  </div>
                )}

                {activeTab === 'documents' && (
                  <button className="dsr-btn-primary" style={btnPrimary}
                    onClick={() => fileInputRef.current?.click()}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#3730a3'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor=T.accent; }}>
                    <Upload size={13} /> Upload File
                  </button>
                )}

                {activeTab === 'knowledge-base' && (
                  <button className="dsr-btn-primary" style={btnPrimary}
                    onClick={() => { getallavailablekbtags(); setshowkb(true); }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#3730a3'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor=T.accent; }}>
                    <Plus size={13} /> Add Resource
                  </button>
                )}

                {activeTab === 'updates' && (
                  <button className="dsr-btn-secondary"
                    style={btnSecondary}
                    onClick={() => setShowSearchmessages(!showSearchmessages)}
                    onMouseEnter={(e) => { e.currentTarget.style.borderColor='#4338ca'; e.currentTarget.style.color='#4338ca'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.color='#374151'; }}>
                    <Search size={13} /> Search
                  </button>
                )}
              </div>

              {/* ── TAB CONTENT ── */}
              <div style={{ flex:1, overflowY:'auto', padding:'24px', animation:'slideUp 0.25s ease' }}>

                {/* ═══ SUCCESS PLAN ═══ */}
                {activeTab === 'success-plan' && (
                  <div style={{ backgroundColor:T.white, borderRadius:'10px', border:`1px solid #e5e7eb`, boxShadow:'0 1px 4px rgba(0,0,0,0.06)', overflow:'hidden' }}>
                    {taskGroups.map((group, groupIndex) => (
                      <div key={group.id} style={{ borderBottom: groupIndex === taskGroups.length-1 ? 'none' : `2px solid #f1f5f9` }}>
                        {/* Group header */}
                        <div
                          draggable={true}
                          onDragStart={(e) => handleGroupDragStart(e, group.id)}
                          onDragOver={(e) => handleGroupDragOver(e, groupIndex)}
                          onDragLeave={handleGroupDragLeave}
                          onDrop={(e) => handleGroupDrop(e, groupIndex)}
                          onDragEnd={handleDragEnd}
                          style={{ backgroundColor: dragOverGroupIndex === groupIndex ? '#e0e7ff' : '#f9fafb', padding:'12px 20px', cursor:'move', borderBottom: expandedGroups.has(group.id) ? `1px solid #e5e7eb` : 'none', border: dragOverGroupIndex === groupIndex ? `2px dashed ${T.accent}` : 'none' }}
                        >
                          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                            <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                              <button onClick={() => toggleGroup(group.id)} style={{ color:T.textMuted, cursor:'pointer', border:'none', background:'none', display:'flex', padding:'2px' }}>
                                {expandedGroups.has(group.id) ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                              </button>
                              {editingGroup === group.id ? (
                                <input type="text" value={group.title}
                                  onChange={(e) => setTaskGroups(prev => prev.map(g => g.id === group.id ? { ...g, title: e.target.value } : g))}
                                  onBlur={() => { update_group(group.title, group.id); setEditingGroup(null); }}
                                  onKeyDown={(e) => { if (e.key === 'Enter') { update_group(group.title, group.id); setEditingGroup(null); } }}
                                  className="dsr-input"
                                  style={{ fontSize:'15px', fontWeight:'600', color:T.textPrimary, border:`1.5px solid ${T.borderMed}`, borderRadius:'6px', padding:'4px 8px', outline:'none', fontFamily:"'Inter',system-ui,sans-serif" }}
                                  autoFocus />
                              ) : (
                                <span style={{ fontSize:'15px', fontWeight:'600', color:T.textPrimary, cursor:'pointer' }}
                                  onClick={() => setEditingGroup(group.id)}>
                                  {group.title}
                                </span>
                              )}
                              <span style={{ fontSize:'11px', backgroundColor:'#e0e7ff', color:'#3730a3', padding:'2px 8px', borderRadius:'20px', fontWeight:'600' }}>
                                {group.tasks.length} tasks
                              </span>
                            </div>
                            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                              <button onClick={() => setManagingFieldsForGroup(group.id)}
                                style={{ padding:'5px', color:T.accent, cursor:'pointer', border:`1.5px solid ${T.borderMed}`, background:T.white, borderRadius:'6px', display:'flex', transition:'all 0.15s' }}
                                onMouseEnter={(e) => { e.currentTarget.style.borderColor=T.accent; e.currentTarget.style.backgroundColor='#e0e7ff'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.backgroundColor=T.white; }}
                                title="Manage fields">
                                <Settings size={13} />
                              </button>
                              <button onClick={() => deleteTaskGroup(group.id)}
                                className="dsr-btn-destructive"
                                style={{ ...btnDestructive, padding:'4px 6px', height:'26px' }}
                                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#fee2e2'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor='transparent'; }}
                                title="Delete group">
                                <Trash2 size={13} />
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Expanded group tasks table */}
                        {expandedGroups.has(group.id) && (
                          <div>
                            <div style={{ overflowX:'auto' }}>
                              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                                <thead>
                                  <tr style={{ backgroundColor:T.tableHeaderAccent,borderRadius:"14px" , }}>
                                    {['Task','Owner','Shared','Status', ...group.additional_fields.map(f=>f.name),'Actions'].map((col,i) => (
                                      <th key={i} style={{ textAlign:'left',padding:'14px', fontWeight:'700', color:T.white, fontSize:'11px', textTransform:'uppercase', letterSpacing:'0.05em', whiteSpace:'nowrap', minWidth: col==='Task'?'240px': col==='Owner'?'140px': col==='Status'?'120px': col==='Actions'?'80px': '130px' }}>{col}</th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  {group.tasks.map((task) => {
                                    const isLocked = isTaskLocked(task, group.id);
                                    const isDocExpanded = expandedDocs.has(task.id);
                                    return (
                                      <React.Fragment key={task.id}>
                                        <tr className="dsr-table-row"
                                          draggable={true}
                                          onDragStart={(e) => handleTaskDragStart(e, task.id, group.id)}
                                          onDragOver={(e) => handleTaskDragOver(e, task.id)}
                                          onDragLeave={handleTaskDragLeave}
                                          onDragEnd={handleDragEnd}
                                          onDrop={(e) => handleTaskDrop(e, task.id, group.id)}
                                          style={{ borderTop:`1px solid #e5e7eb`, backgroundColor: dragOverTaskId === task.id ? '#e0e7ff' : T.white, opacity: isLocked ? 0.6 : 1, border: dragOverTaskId === task.id ? `2px dashed ${T.accent}` : undefined }}>
                                          
                                          <td style={{ padding:'10px 14px' }}>
                                            <div style={{ display:'flex', alignItems:'flex-start', gap:'7px' }}>
                                              {isLocked && <span title="Locked">🔒</span>}
                                              <div style={{ flex:1 }}>
                                                <div style={{ fontWeight:'500', color:T.textPrimary, fontSize:'13px' }}>{task.title}</div>
                                                {task.description && <div style={{ fontSize:'11px', color:T.textMuted, marginTop:'2px' }}>{task.description}</div>}
                                                {task.dependencies.length > 0 && (
                                                  <div style={{ fontSize:'11px', color:T.textMuted, marginTop:'3px', display:'flex', alignItems:'center', gap:'3px', flexWrap:'wrap' }}>
                                                    <Link size={9} /><span>Depends on:</span>
                                                    {getDependencyNames(task, taskGroups).map((depTitle, i) => (
                                                      <span key={i} style={{ backgroundColor:'#f3f4f6', padding:'1px 6px', borderRadius:'4px', fontSize:'10px' }}>{depTitle}</span>
                                                    ))}
                                                  </div>
                                                )}
                                                {task.documentation && (
                                                  <button style={{ display:'inline-flex', alignItems:'center', fontSize:'11px', color:T.accent, fontWeight:'500', cursor:'pointer', border:'none', background:'none', gap:'3px', padding:'2px 0', marginTop:'3px' }}
                                                    onClick={() => toggleDocumentation(task.id)}>
                                                    <FileText size={9} />
                                                    {isDocExpanded ? 'Hide Docs' : 'View Docs'}
                                                  </button>
                                                )}
                                              </div>
                                            </div>
                                          </td>

                                          <td style={{ padding:'10px 14px' }}>
                                            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                                              <div style={{ width:'26px', height:'26px', backgroundColor:'#6d28d9', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', color:T.white, fontSize:'11px', fontWeight:'600', flexShrink:0 }}>
                                                {(allusersnames.find(user => user.id === task.assignee)?.name || 'U').charAt(0).toUpperCase()}
                                              </div>
                                              <span style={{ fontSize:'12px', color:T.textSecondary }}>
                                                {allusersnames.find(user => user.id === task.assignee)?.name || 'Unassigned'}
                                              </span>
                                            </div>
                                          </td>

                                          <td style={{ padding:'10px 14px' }}>
                                            <button onClick={() => toggleTaskSpecificFields(group.id, task.id, 'sharedInPortal', !task.sharedInPortal)}
                                              style={{ width:'38px', height:'20px', borderRadius:'10px', backgroundColor: task.sharedInPortal ? T.accent : '#d1d5db', border:'none', cursor:'pointer', position:'relative', transition:'background-color 0.2s' }}>
                                              <div style={{ width:'14px', height:'14px', backgroundColor:T.white, borderRadius:'50%', boxShadow:'0 1px 3px rgba(0,0,0,0.15)', position:'absolute', top:'3px', left: task.sharedInPortal ? '21px' : '3px', transition:'left 0.2s' }} />
                                            </button>
                                          </td>

                                          <td style={{ padding:'10px 14px' }}>
                                            <select value={task.status}
                                              onChange={(e) => toggleTaskSpecificFields(group.id, task.id, 'status', e.target.value)}
                                              disabled={isLocked}
                                              className="dsr-input form-select"
                                              style={{ padding:'5px 10px', paddingRight: '28px',borderRadius:'6px', fontSize:'12px', fontWeight:'600', WebkitAppearance:'none', MozAppearance:'none', appearance:'none', backgroundImage:"url(\"data:image/svg+xml;utf8,<svg fill='none' stroke='%234b5563' stroke-width='2' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'/></svg>\")", backgroundRepeat:'no-repeat', backgroundPosition:'right 8px center', backgroundSize:'12px', cursor: isLocked ? 'not-allowed' : 'pointer', border:`1.5px solid ${T.borderMed}`, ...getStatusColor(task.status) }}>
                                              {statusOptions.map(status => (
                                                <option key={status} value={status}>{status.charAt(0).toUpperCase()+status.slice(1).replace('-',' ')}</option>
                                              ))}
                                            </select>
                                          </td>

                                          {group.additional_fields.map(field => (
                                            <td key={field.name} style={{ padding:'10px 14px' }}>
                                              {renderFieldInput(group, task, field)}
                                            </td>
                                          ))}

                                          <td style={{ padding:'10px 14px' }}>
                                            <div style={{ display:'flex', alignItems:'center', gap:'4px' }}>
                                              <button onClick={() => { setavailableSteps(taskGroups.flatMap(g => g.tasks.filter(s => s.id !== task.id).map(s => ({ ...s, groupId: g.id })))); setEditingStep({ step: task, groupId: group.id }); }}
                                                style={{ padding:'4px 6px', color:T.accent, cursor:'pointer', border:`1.5px solid ${T.borderMed}`, background:T.white, borderRadius:'6px', display:'flex', transition:'all 0.15s' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.borderColor=T.accent; e.currentTarget.style.backgroundColor='#e0e7ff'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.backgroundColor=T.white; }}
                                                title="Edit task">
                                                <Edit3 size={12} />
                                              </button>
                                              <button onClick={() => deleteTask(group.id, task.id)}
                                                className="dsr-btn-destructive"
                                                style={{ ...btnDestructive, padding:'4px 6px', height:'26px' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#fee2e2'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor='transparent'; }}
                                                title="Delete task">
                                                <Trash2 size={12} />
                                              </button>
                                            </div>
                                          </td>
                                        </tr>

                                        {isDocExpanded && task.documentation && (
                                          <tr>
                                            <td colSpan={8 + (group.additional_fields?.length||0)} style={{ padding:'0 14px 10px 14px' }}>
                                              <div style={{ background:'linear-gradient(to right,#eff6ff,#eef2ff)', border:`1px solid #c7d2fe`, borderRadius:'8px', padding:'12px', marginLeft:'28px', boxShadow:'0 1px 3px rgba(0,0,0,0.06)' }}>
                                                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'8px' }}>
                                                  <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                                                    <div style={{ width:'6px', height:'6px', backgroundColor:T.accent, borderRadius:'50%' }} />
                                                    <h4 style={{ fontSize:'12px', fontWeight:'700', color:'#1e3a8a', margin:0 }}>Documentation</h4>
                                                  </div>
                                                  <button style={{ color:'#60a5fa', cursor:'pointer', border:'none', background:'none', padding:'2px', display:'flex' }}
                                                    onClick={() => toggleDocumentation(task.id)}>
                                                    <X size={13} />
                                                  </button>
                                                </div>
                                                <div className="quill-editor">
                                                  <RichTextEditor value={task.documentation} view_only={true} placeholder="" />
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        )}
                                      </React.Fragment>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>

                            <div style={{ padding:'10px 20px', borderTop:`1px solid #f1f5f9`, backgroundColor:'#fafafa' }}>
                              <button onClick={() => addStep(group.id)}
                                style={{ display:'flex', alignItems:'center', gap:'6px', color:T.accent, fontSize:'12px', fontWeight:'600', cursor:'pointer', border:'none', background:'none', padding:'4px 0' }}
                                onMouseEnter={(e) => { e.currentTarget.style.color=T.tableHeaderAccent; }}
                                onMouseLeave={(e) => { e.currentTarget.style.color=T.accent; }}>
                                <Plus size={13} />
                                Add task to {group.title}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}

                    {(!taskGroups || taskGroups.length === 0) && (
                      <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'64px 24px', animation:'fadeIn 0.4s ease' }}>
                        <div style={{ width:'56px', height:'56px', backgroundColor:'#e5e7eb', borderRadius:'12px', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:'16px' }}>
                          <Target size={24} color={T.textMuted} />
                        </div>
                        <h3 style={{ margin:'0 0 8px 0', fontSize:'16px', fontWeight:'700', color:T.textPrimary }}>No Groups Available</h3>
                        <p style={{ margin:0, fontSize:'13px', color:T.textMuted, textAlign:'center' }}>Add a group using the Actions menu above.</p>
                      </div>
                    )}

                    {/* Field Management Modal */}
                    {managingFieldsForGroup && (
                      <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, backgroundColor:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
                        <div style={{ backgroundColor:T.white, borderRadius:'12px', padding:'28px', width:'580px', maxWidth:'90vw', maxHeight:'80vh', overflow:'auto', boxShadow:'0 20px 60px rgba(0,0,0,0.35)', border:`1px solid ${T.border}` }}>
                          <h3 style={{ margin:'0 0 20px 0', fontSize:'17px', fontWeight:'700', color:T.textPrimary }}>Manage Additional Fields</h3>
                          <div style={{ marginBottom:'20px' }}>
                            <div style={{ display:'flex', flexDirection:'column', gap:'8px' }}>
                              {taskGroups.find(g => g.id === managingFieldsForGroup)?.additional_fields?.map((field, i) => (
                                <div key={i} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px', backgroundColor:'#f3f4f6', borderRadius:'8px', border:`1px solid ${T.border}` }}>
                                  <div style={{ flex:1 }}>
                                    <span style={{ fontSize:'13px', color:T.textSecondary, fontWeight:'600' }}>{field.name}</span>
                                    <div style={{ fontSize:'11px', color:T.textMuted, marginTop:'2px' }}>
                                      Type: {field.type.replace('_',' ').charAt(0).toUpperCase()+field.type.replace('_',' ').slice(1)}
                                      {field.options?.length > 0 && <span> · Options: {field.options.join(', ')}</span>}
                                    </div>
                                  </div>
                                  <button onClick={() => deleteaddtionalfield(field.id)}
                                    className="dsr-btn-destructive"
                                    style={{ ...btnDestructive, padding:'4px 8px' }}
                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#fee2e2'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor='transparent'; }}>
                                    <X size={13} />
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>

                          <div style={{ marginBottom:'20px', padding:'18px', backgroundColor:'#f9fafb', borderRadius:'10px', border:`1px solid ${T.border}` }}>
                            <h4 style={{ margin:'0 0 14px 0', fontSize:'14px', fontWeight:'700', color:T.textPrimary }}>Add New Field</h4>
                            <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
                              <div>
                                <label style={{ display:'block', marginBottom:'4px', fontWeight:'600', fontSize:'12px', color:T.textSecondary }}>Field Name</label>
                                <input type="text" value={newFieldName} onChange={(e) => setNewFieldName(e.target.value)} placeholder="Enter field name" className="dsr-input"
                                  style={{ width:'100%', padding:'8px 12px', border:`1.5px solid ${T.borderMed}`, borderRadius:'8px', fontSize:'13px', fontFamily:"'Inter',system-ui,sans-serif", color:T.textPrimary, outline:'none' }} />
                              </div>
                              <div>
                                <label style={{ display:'block', marginBottom:'4px', fontWeight:'600', fontSize:'12px', color:T.textSecondary }}>Field Type</label>
                                <select value={newFieldType} onChange={(e) => setNewFieldType(e.target.value)} className="dsr-input form-select"
                                  style={{ width:'100%', padding:'8px 12px', border:`1.5px solid ${T.borderMed}`, borderRadius:'8px', fontSize:'13px', fontFamily:"'Inter',system-ui,sans-serif", color:T.textPrimary, WebkitAppearance:'none', MozAppearance:'none', appearance:'none', backgroundImage:"url(\"data:image/svg+xml;utf8,<svg fill='none' stroke='%234b5563' stroke-width='2' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'/></svg>\")", backgroundRepeat:'no-repeat', backgroundPosition:'right 12px center', backgroundSize:'14px', backgroundColor:T.white, outline:'none' }}>
                                  {fieldTypes.map(type => <option key={type.value} value={type.value}>{type.label}</option>)}
                                </select>
                              </div>
                              {(newFieldType === 'single_choice' || newFieldType === 'multiple_choice') && (
                                <div>
                                  <label style={{ display:'block', marginBottom:'4px', fontWeight:'600', fontSize:'12px', color:T.textSecondary }}>Options (comma-separated)</label>
                                  <input type="text" value={newFieldOptions} onChange={(e) => setNewFieldOptions(e.target.value)} placeholder="Option 1, Option 2, Option 3" className="dsr-input"
                                    style={{ width:'100%', padding:'8px 12px', border:`1.5px solid ${T.borderMed}`, borderRadius:'8px', fontSize:'13px', fontFamily:"'Inter',system-ui,sans-serif", color:T.textPrimary, outline:'none' }} />
                                </div>
                              )}
                              <button onClick={() => addFieldToGroup(managingFieldsForGroup, newFieldName, newFieldType, newFieldOptions)}
                                disabled={!newFieldName.trim()}
                                className="dsr-btn-primary"
                                style={{ ...btnPrimary, alignSelf:'flex-start', opacity: !newFieldName.trim()?0.5:1 }}
                                onMouseEnter={(e) => { if (newFieldName.trim()) e.currentTarget.style.backgroundColor='#3730a3'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor=T.accent; }}>
                                Add Field
                              </button>
                            </div>
                          </div>

                          <div style={{ display:'flex', justifyContent:'flex-end' }}>
                            <button onClick={() => { setManagingFieldsForGroup(null); setNewFieldName(''); setNewFieldType('text'); setNewFieldOptions(''); }}
                              className="dsr-btn-secondary"
                              style={btnSecondary}
                              onMouseEnter={(e) => { e.currentTarget.style.borderColor=T.accent; e.currentTarget.style.color=T.accent; }}
                              onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.color='#374151'; }}>
                              Done
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Edit Task Modal */}
                    {editingStep && (
                     <EditModal
                    editingStep={editingStep}
                    setEditingStep={setEditingStep}
                    updateStep={updateStep}
                    availableSteps={availableSteps}
                    taskGroups={taskGroups}
                    statusOptions={statusOptions}
                    RichTextEditor={RichTextEditor}  // optional — falls back to <textarea>
                  />
                    )}
                  </div>
                )}

                {/* ═══ ANALYTICS ═══ */}
                {activeTab === 'analytics' && (
                  <div style={{ animation:'slideUp 0.25s ease' }}>
                    {/* Summary cards */}
                    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(180px,1fr))', gap:'16px', marginBottom:'24px' }}>
                      {[
                        { label:'Total Tasks', value:totalTasks, color:'#4338ca' },
                        { label:'Completed', value:completedTasks, color:'#15803d' },
                        { label:'Overall Progress', value:`${overallProgress}%`, color:'#4338ca' },
                        { label:'Active Groups', value:activeGroups, color:'#6d28d9' },
                      ].map((card, i) => (
                        <div key={i} className="dsr-card"
                          style={{ backgroundColor:T.white, border:`1px solid #e5e7eb`, borderRadius:'10px', padding:'20px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', textAlign:'center' }}>
                          <div style={{ fontSize:'11px', fontWeight:'600', color:T.textMuted, textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:'6px' }}>{card.label}</div>
                          <div style={{ fontSize:'28px', fontWeight:'780', color:card.color, letterSpacing:'-0.5px' }}>{card.value}</div>
                        </div>
                      ))}
                    </div>

                    {/* Progress overview */}
                    <div style={{ backgroundColor:T.white, borderRadius:'10px', border:`1px solid #e5e7eb`, padding:'24px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', marginBottom:'24px' }}>
                      <h3 style={{ margin:'0 0 20px 0', fontSize:'15px', fontWeight:'700', color:T.textPrimary, display:'flex', alignItems:'center', gap:'8px' }}>
                        <BarChart3 size={18} color={T.accent} /> Success Plan Progress Overview
                      </h3>
                      {taskGroups.map((group, i) => {
                        const completedCount = group.tasks.filter(t => t.status === 'done').length;
                        const totalCount = group.tasks.length;
                        const pct = totalCount ? Math.round((completedCount / totalCount) * 100) : 0;
                        const barColor = pct===100?'#15803d':pct>=75?T.accent:pct>=50?'#b45309':'#b91c1c';
                        return (
                          <div key={group.id} style={{ marginBottom: i===taskGroups.length-1?0:'18px', backgroundColor:'#f9fafb', borderRadius:'8px', padding:'16px', border:`1px solid ${T.border}` }}>
                            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'10px' }}>
                              <span style={{ fontWeight:'600', color:T.textPrimary, fontSize:'13px' }}>{group.title}</span>
                              <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                                <span style={{ fontSize:'12px', color:T.textMuted }}>{completedCount}/{totalCount}</span>
                                <span style={{ padding:'3px 10px', backgroundColor:`${barColor}22`, color:barColor, borderRadius:'12px', fontSize:'11px', fontWeight:'700' }}>{pct}%</span>
                              </div>
                            </div>
                            <div style={{ height:'7px', backgroundColor:'#e5e7eb', borderRadius:'4px', overflow:'hidden' }}>
                              <div style={{ height:'100%', width:`${pct}%`, backgroundColor:barColor, borderRadius:'4px', transition:'width 0.5s cubic-bezier(0.4,0,0.2,1)' }} />
                            </div>
                            <div style={{ marginTop:'8px', display:'flex', gap:'14px', fontSize:'11px', color:T.textMuted }}>
                              <span><strong style={{ color:'#15803d' }}>{group.tasks.filter(t=>t.status==='done').length}</strong> Done</span>
                              <span><strong style={{ color:T.accent }}>{group.tasks.filter(t=>t.status==='in-progress').length}</strong> In Progress</span>
                              <span><strong style={{ color:'#b45309' }}>{group.tasks.filter(t=>t.status==='pending').length}</strong> Pending</span>
                              <span><strong style={{ color:'#b91c1c' }}>{group.tasks.filter(t=>t.status==='overdue').length}</strong> Overdue</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    <AnalyticsComponent
                      blocks={blocks} setblocks={setblocks} get_chart={get_chart}
                      editingblocks={editingblocks} seteditingblocks={seteditingblocks}
                      delete_block={delete_KPI} handleEdit={handle_KPI_edit} updateBlockPosition={updateBlockPosition} />
                  </div>
                )}

                {/* ═══ DOCUMENTS ═══ */}
                {activeTab === 'documents' && (
                  <div style={{ animation:'slideUp 0.25s ease' }}>
                    {/* Search */}
                    <div style={{ marginBottom:'16px', position:'relative', maxWidth:'360px' }}>
                      <Search size={14} style={{ position:'absolute', left:'12px', top:'50%', transform:'translateY(-50%)', color:T.textMuted, pointerEvents:'none' }} />
                      <input type="text" placeholder="Search documents..." value={searchDocument}
                        onChange={(e) => setsearchDocument(e.target.value)}
                        className="dsr-input"
                        style={{ width:'100%', padding:'8px 12px 8px 36px', border:`1.5px solid ${T.borderMed}`, borderRadius:'8px', fontSize:'13px', color:T.textPrimary, backgroundColor:T.white, fontFamily:"'Inter',system-ui,sans-serif", outline:'none' }} />
                    </div>

                    {/* Upload area */}
                    <div
                      onDragEnter={handleDocumentDrag} onDragLeave={handleDocumentDrag}
                      onDragOver={handleDocumentDrag} onDrop={handleDocumentDrop}
                      style={{ border:`2px dashed ${dragActive?T.accent:T.borderMed}`, borderRadius:'12px', padding:'36px 24px', marginBottom:'20px', textAlign:'center', backgroundColor: dragActive?'#e0e7ff':'#f9fafb', transition:'all 0.25s', cursor:'pointer' }}
                      onMouseEnter={(e) => { e.currentTarget.style.borderColor=T.accent; e.currentTarget.style.backgroundColor='#eef2ff'; }}
                      onMouseLeave={(e) => { if (!dragActive) { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.backgroundColor='#f9fafb'; } }}>
                      <Upload size={36} color={T.textMuted} style={{ marginBottom:'10px', opacity:0.7 }} />
                      <p style={{ margin:'0 0 4px 0', fontSize:'14px', fontWeight:'600', color:T.textPrimary }}>Drag and drop files here</p>
                      <p style={{ margin:'0 0 14px 0', fontSize:'12px', color:T.textMuted }}>Support for PDF, Images, Spreadsheets, Videos, Audio and more</p>
                      <button onClick={() => fileInputRef.current?.click()}
                        className="dsr-btn-primary" style={btnPrimary}
                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#3730a3'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor=T.accent; }}>
                        Choose Files
                      </button>
                    </div>

                    {/* Documents list */}
                    <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
                      {filteredDocuments.map(doc => (
                        <div key={doc.id} className="dsr-card"
                          style={{ backgroundColor:T.white, border:`1px solid #e5e7eb`, borderRadius:'10px', padding:'14px 18px', display:'flex', justifyContent:'space-between', alignItems:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', transition:'all 0.15s' }}>
                          <div style={{ display:'flex', alignItems:'center', gap:'14px', flex:1 }}>
                            {getFileIcon(doc.type)}
                            <div style={{ flex:1 }}>
                              <h3 style={{ margin:'0 0 4px 0', fontSize:'14px', fontWeight:'600', color:T.textPrimary }}>{doc.name}</h3>
                              <div style={{ display:'flex', alignItems:'center', gap:'10px', fontSize:'12px', color:T.textMuted }}>
                                <span>{doc.uploadDate}</span>
                                <span style={{ padding:'2px 10px', backgroundColor:'#f3f4f6', color:T.textSecondary, borderRadius:'20px', fontSize:'11px', fontWeight:'500', border:`1px solid ${T.border}` }}>{doc.uploadedBy}</span>
                              </div>
                            </div>
                          </div>
                          <div style={{ display:'flex', gap:'6px' }}>
                            <button onClick={() => downloadDocument(doc.url)}
                              style={{ padding:'7px', border:`1.5px solid ${T.borderMed}`, borderRadius:'7px', cursor:'pointer', display:'flex', alignItems:'center', backgroundColor:T.white, color:T.textSecondary, transition:'all 0.15s' }}
                              onMouseEnter={(e) => { e.currentTarget.style.borderColor=T.accent; e.currentTarget.style.color=T.accent; }}
                              onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.color=T.textSecondary; }}
                              title="Download">
                              <Download size={14} />
                            </button>
                            <button onClick={() => deleteDocument(doc.id)}
                              className="dsr-btn-destructive" style={{ ...btnDestructive, padding:'6px 8px' }}
                              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#fee2e2'; }}
                              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor='transparent'; }}
                              title="Delete">
                              <Trash2 size={14} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>

                    {filteredDocuments.length === 0 && (
                      <div style={{ textAlign:'center', padding:'56px 24px', animation:'fadeIn 0.4s ease' }}>
                        <div style={{ width:'56px', height:'56px', backgroundColor:'#e5e7eb', borderRadius:'12px', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px auto' }}>
                          <File size={24} color={T.textMuted} />
                        </div>
                        <p style={{ margin:'0 0 6px 0', fontSize:'15px', fontWeight:'700', color:T.textPrimary }}>No documents found</p>
                        <p style={{ margin:0, fontSize:'13px', color:T.textMuted }}>Upload your first document to get started</p>
                      </div>
                    )}

                    <input ref={fileInputRef} type="file" multiple accept="*/*"
                      onChange={(e) => handleFiles(e.target.files)} style={{ display:'none' }} />
                  </div>
                )}

                {/* ═══ UPDATES ═══ */}
                {activeTab === 'updates' && (
                  <div style={{ display:'flex', flexDirection:'column', height:'calc(100vh - 220px)', animation:'slideUp 0.25s ease' }}>
                    {/* Search panel */}
                    {showSearchmessages && (
                      <div style={{ backgroundColor:T.white, border:`1px solid ${T.border}`, borderRadius:'10px', padding:'14px 18px', marginBottom:'14px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
                        <div style={{ position:'relative', marginBottom:'10px' }}>
                          <Search size={14} style={{ position:'absolute', left:'12px', top:'50%', transform:'translateY(-50%)', color:T.textMuted }} />
                          <input type="text" placeholder="Search messages..." value={searchQuerymessages}
                            onChange={(e) => setSearchQuerymessages(e.target.value)}
                            className="dsr-input"
                            style={{ width:'100%', padding:'8px 36px 8px 36px', border:`1.5px solid ${T.borderMed}`, borderRadius:'8px', fontSize:'13px', color:T.textPrimary, backgroundColor:T.white, fontFamily:"'Inter',system-ui,sans-serif", outline:'none' }} />
                          {searchQuerymessages && (
                            <button onClick={clearSearchmessages} style={{ position:'absolute', right:'10px', top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:T.textMuted, display:'flex' }}>
                              <X size={14} />
                            </button>
                          )}
                        </div>
                        <div style={{ display:'flex', gap:'6px', marginBottom:'8px' }}>
                          {['all','content','author'].map(type => (
                            <button key={type} onClick={() => setSearchTypemessages(type)}
                              style={{ padding:'5px 12px', border:'none', borderRadius:'7px', fontSize:'12px', fontWeight:'600', cursor:'pointer', fontFamily:"'Inter',system-ui,sans-serif",
                                background: searchTypemessages===type ? `linear-gradient(135deg,${T.accent},${T.tableHeaderAccent})` : '#e5e7eb',
                                color: searchTypemessages===type ? T.white : T.textMuted,
                                transition:'all 0.15s'
                              }}>
                              {type.charAt(0).toUpperCase()+type.slice(1)}
                            </button>
                          ))}
                        </div>
                        {searchQuerymessages && <div style={{ fontSize:'12px', color:T.textMuted }}>Found {filteredMessages.length} message{filteredMessages.length !== 1 ? 's' : ''}</div>}
                      </div>
                    )}

                    {/* Messages */}
                    <div ref={chatMessagesRef} onScroll={handleScroll}
                      style={{ flex:1, overflowY:'auto', backgroundColor:T.white, borderRadius:'10px', border:`1px solid #e5e7eb`, padding:'16px 20px', display:'flex', flexDirection:'column', gap:'12px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', marginBottom:'12px' }}>
                      {showLoadMore && (
                        <button onClick={loadMoreMessages}
                          style={{ position:'sticky', top:'8px', alignSelf:'center', padding:'8px 18px', background:`linear-gradient(135deg,${T.accent},${T.tableHeaderAccent})`, color:T.white, border:'none', borderRadius:'20px', cursor:'pointer', fontSize:'12px', fontWeight:'700', boxShadow:'0 2px 8px rgba(67,56,202,0.40)', zIndex:10, fontFamily:"'Inter',system-ui,sans-serif", transition:'all 0.15s' }}
                          onMouseEnter={(e) => { e.currentTarget.style.transform='translateY(-1px)'; e.currentTarget.style.boxShadow='0 4px 12px rgba(67,56,202,0.45)'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow='0 2px 8px rgba(67,56,202,0.40)'; }}>
                          Load older messages
                        </button>
                      )}

                      {filteredMessages.map(message => (
                        <div key={message.id} style={{ display:'flex', justifyContent: message.authorid === userid ? 'flex-end' : 'flex-start' }}>
                          <div style={{ position:'relative', paddingBottom:'28px', maxWidth:'68%', minWidth:'180px' }}>
                            <div style={{ borderRadius: message.authorid===userid ? '14px 14px 4px 14px' : '14px 14px 14px 4px', padding:'12px 16px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)',
                              ...(message.authorid===userid
                                ? { background:`linear-gradient(135deg,${T.accent},${T.tableHeaderAccent})`, color:T.white }
                                : { backgroundColor:T.white, color:T.textPrimary, border:`1px solid ${T.border}` })
                            }}>
                              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'6px', gap:'16px' }}>
                                <span style={{ fontWeight:'700', fontSize:'12px', opacity:0.9 }}>
                                  {searchQuerymessages && (searchTypemessages==='all'||searchTypemessages==='author')
                                    ? highlightTextmessages(message.author, searchQuerymessages) : message.author}
                                </span>
                                <span style={{ fontSize:'11px', opacity:0.65, whiteSpace:'nowrap' }}>{message.time}</span>
                              </div>
                              <div style={{ fontSize:'13px', lineHeight:'1.5', wordBreak:'break-word' }}>
                                {searchQuerymessages && (searchTypemessages==='all'||searchTypemessages==='content')
                                  ? highlightTextmessages(message.content, searchQuerymessages) : message.content}
                              </div>
                            </div>
                            {message.authorid === userid && (
                              <button onClick={() => deletemessage(message.id)}
                                style={{ position:'absolute', bottom:'4px', right:'4px', width:'24px', height:'24px', backgroundColor:'#fef2f2', color:'#b91c1c', display:'flex', alignItems:'center', justifyContent:'center', borderRadius:'6px', border:'1.5px solid #fca5a5', cursor:'pointer', transition:'all 0.15s' }}
                                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#fee2e2'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor='#fef2f2'; }}>
                                <Trash2 size={11} />
                              </button>
                            )}
                          </div>
                        </div>
                      ))}

                      {filteredMessages.length === 0 && (
                        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'200px', animation:'fadeIn 0.4s ease' }}>
                          <div style={{ width:'56px', height:'56px', backgroundColor:'#e5e7eb', borderRadius:'12px', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:'14px' }}>
                            <MessageCircle size={24} color={T.textMuted} />
                          </div>
                          <p style={{ fontSize:'15px', fontWeight:'700', color:T.textPrimary, margin:'0 0 4px 0' }}>
                            {searchQuerymessages ? 'No messages found' : 'No updates yet'}
                          </p>
                          <p style={{ fontSize:'12px', color:T.textMuted, margin:0 }}>
                            {searchQuerymessages ? 'Try a different search term' : 'Send the first update to get started'}
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Input area */}
                    <div style={{ position:'relative', backgroundColor:T.white, borderRadius:'10px', border:`1px solid #e5e7eb`, padding:'12px 14px', display:'flex', gap:'10px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
                      <input ref={chatInputRef} type="text" placeholder="Type a message... (@ to mention)"
                        value={chatInput} onChange={handleChatInputChange}
                        onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                        className="dsr-input"
                        style={{ flex:1, padding:'9px 14px', border:`1.5px solid ${T.borderMed}`, borderRadius:'8px', fontSize:'13px', backgroundColor:'#f9fafb', fontFamily:"'Inter',system-ui,sans-serif", color:T.textPrimary, outline:'none', transition:'border-color 0.15s' }} />
                      <button onClick={sendMessage}
                        className="dsr-btn-primary" style={{ ...btnPrimary, height:'auto', padding:'9px 18px' }}
                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#3730a3'; e.currentTarget.style.transform='translateY(-1px)'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor=T.accent; e.currentTarget.style.transform='translateY(0)'; }}>
                        <Send size={13} /> Send
                      </button>
                      {showUserList && (
                        <div style={{ position:'absolute', bottom:'100%', left:0, right:0, backgroundColor:T.white, borderRadius:'10px', boxShadow:'0 8px 24px rgba(0,0,0,0.12)', border:`1px solid ${T.border}`, maxHeight:'180px', overflowY:'auto', zIndex:1000, marginBottom:'6px' }}>
                          {allusersnames.filter(user => user.name.toLowerCase().includes(currentMentionSearch.toLowerCase())).map(user => (
                            <div key={user.id}
                              onClick={() => selectUser(user.id, user.name)}
                              className="dsr-dropdown-item"
                              style={{ padding:'9px 14px', cursor:'pointer', fontSize:'13px', color:T.textSecondary, borderBottom:`1px solid #f3f4f6`, fontWeight:'500' }}>
                              {user.name}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* ═══ SETTINGS ═══ */}
                {activeTab === 'settings' && (
                  <div style={{ animation:'slideUp 0.25s ease' }}>
                    {/* Settings sidebar sub-nav */}
                    <div style={{ display:'flex', gap:'8px', marginBottom:'20px' }}>
                      {settingsGroups.map(group => (
                        <button key={group.id}
                          style={{ padding:'7px 16px', borderRadius:'8px', border:`1.5px solid ${selectedGroupId===group.id?T.accent:T.borderMed}`, backgroundColor: selectedGroupId===group.id?'#e0e7ff':T.white, color: selectedGroupId===group.id?T.tableHeaderAccent:T.textSecondary, fontWeight: selectedGroupId===group.id?'700':'500', fontSize:'13px', cursor:'pointer', fontFamily:"'Inter',system-ui,sans-serif", transition:'all 0.15s', display:'flex', alignItems:'center', gap:'6px' }}
                          onClick={() => { setgroup_name(group.title); setSelectedGroupId(group.id); }}>
                          <Shield size={13} /> {group.title}
                        </button>
                      ))}
                    </div>

                    {selectedGroupId === '0' && (
                      <div style={{ backgroundColor:T.white, borderRadius:'10px', border:`1px solid #e5e7eb`, overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
                        {/* Header */}
                        <div style={{ background:`linear-gradient(135deg,${T.accent},${T.accent2})`, padding:'18px 22px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                          <h2 style={{ margin:0, fontSize:'16px', fontWeight:'700', color:T.white, display:'flex', alignItems:'center', gap:'8px' }}>
                            <Shield size={18} /> User Permission Management
                          </h2>
                          <div style={{ display:'flex', gap:'16px', fontSize:'12px', color:'rgba(255,255,255,0.85)' }}>
                            <span><strong>{allusersnames.length}</strong> total</span>
                            <span><strong>{stats.view||0}</strong> view</span>
                            <span><strong>{stats.edit||0}</strong> edit</span>
                            <span><strong>{stats.internal||0}</strong> internal</span>
                          </div>
                        </div>

                        <div style={{ padding:'8px' }}>
                          {allusersnames.map((user_x) => (
                            <div key={user_x.id} className="dsr-table-row"
                              style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 18px', borderRadius:'8px', marginBottom:'4px', border:`1px solid transparent`, transition:'all 0.15s' }}
                              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#f5f3ff'; e.currentTarget.style.borderColor='#c7d2fe'; }}
                              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor='transparent'; e.currentTarget.style.borderColor='transparent'; }}>
                              <div style={{ display:'grid', gridTemplateColumns:'1fr auto auto', alignItems:'center', gap:'20px', width:'100%' }}>
                                <div>
                                  <div style={{ fontSize:'14px', fontWeight:'600', color:T.textPrimary }}>{user_x.name}</div>
                                  <div style={{ fontSize:'12px', color:T.textMuted }}>{user_x.email}</div>
                                </div>
                                <div style={{ display:'flex', alignItems:'center', gap:'6px', padding:'5px 12px', backgroundColor:`${useraccesslevelcolors[user_x.accesslevel?.toLowerCase()]||'#4338ca'}22`, borderRadius:'20px', fontSize:'11px', fontWeight:'700', color: useraccesslevelcolors[user_x.accesslevel?.toLowerCase()]||T.accent, textTransform:'uppercase', letterSpacing:'0.05em', border:`1px solid ${useraccesslevelcolors[user_x.accesslevel?.toLowerCase()]||T.accent}44` }}>
                                  {user_x.accesslevel?.toLowerCase()==='view' && <Eye size={12} />}
                                  {user_x.accesslevel?.toLowerCase()==='internal' && <User size={12} />}
                                  {user_x.accesslevel?.toLowerCase()==='edit' && <Edit2 size={12} />}
                                  {user_x.accesslevel}
                                </div>
                                <div style={{ display:'flex', gap:'6px' }}>
                                  {user_x.accesslevel?.toLowerCase() !== 'internal' ? (
                                    <>
                                      <button onClick={() => revokeaccess(user_x.id)}
                                        className="dsr-btn-destructive"
                                        style={{ ...btnDestructive, padding:'5px 12px' }}
                                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#fee2e2'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor='transparent'; }}>
                                        Revoke
                                      </button>
                                      <button onClick={() => { setshareusername(user_x.name); setshareemailid(user_x.email); setshareuserid(user_x.id); setshareuseraccess(user_x.accesslevel); setshoweditaccess(true); }}
                                        className="dsr-btn-secondary" style={{ ...btnSecondary, height:'28px', fontSize:'12px', padding:'0 12px' }}
                                        onMouseEnter={(e) => { e.currentTarget.style.borderColor=T.accent; e.currentTarget.style.color=T.accent; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.color='#374151'; }}>
                                        Edit Access
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button style={{ ...btnDestructive, padding:'5px 12px', opacity:0.4, cursor:'not-allowed' }} disabled>Revoke</button>
                                      <button style={{ ...btnSecondary, height:'28px', fontSize:'12px', padding:'0 12px', opacity:0.4, cursor:'not-allowed' }} disabled>Edit Access</button>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* ═══ KNOWLEDGE BASE ═══ */}
                {activeTab === 'knowledge-base' && (
                  <div style={{ animation:'slideUp 0.25s ease' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:'12px', marginBottom:'16px' }}>
                      <div style={{ position:'relative', flex:1, maxWidth:'360px' }}>
                        <Search size={14} style={{ position:'absolute', left:'12px', top:'50%', transform:'translateY(-50%)', color:T.textMuted, pointerEvents:'none' }} />
                        <input type="text" placeholder="Search knowledge base..." value={searchknowledgebase}
                          onChange={(e) => setsearchknowledgebase(e.target.value)}
                          className="dsr-input"
                          style={{ width:'100%', padding:'8px 12px 8px 36px', border:`1.5px solid ${T.borderMed}`, borderRadius:'8px', fontSize:'13px', color:T.textPrimary, backgroundColor:T.white, fontFamily:"'Inter',system-ui,sans-serif", outline:'none' }} />
                      </div>
                      <button onClick={() => setShowFilters(!showFilters)}
                        style={{ display:'flex', alignItems:'center', gap:'6px', padding:'8px 14px', border:`1.5px solid ${showFilters?T.accent:T.borderMed}`, borderRadius:'8px', fontSize:'12px', fontWeight:'600', cursor:'pointer', fontFamily:"'Inter',system-ui,sans-serif", backgroundColor: showFilters?'#e0e7ff':T.white, color: showFilters?T.tableHeaderAccent:'#374151', transition:'all 0.15s' }}>
                        <Filter size={13} /> Filters
                        <ChevronDown size={13} style={{ transform: showFilters?'rotate(180deg)':'rotate(0deg)', transition:'transform 0.25s' }} />
                      </button>
                    </div>

                    {showFilters && (
                      <div style={{ backgroundColor:'#f9fafb', border:`1.5px solid ${T.border}`, borderRadius:'10px', padding:'16px', marginBottom:'20px' }}>
                        <h3 style={{ margin:'0 0 12px 0', fontSize:'12px', fontWeight:'700', color:T.textSecondary, textTransform:'uppercase', letterSpacing:'0.06em' }}>Filter by Tags</h3>
                        <div style={{ display:'flex', flexWrap:'wrap', gap:'6px' }}>
                          {allTags.map(tag => (
                            <button key={tag} onClick={() => toggleTag(tag)}
                              style={{ padding:'5px 12px', border:`1.5px solid ${selectedTags.includes(tag)?T.accent:T.borderMed}`, borderRadius:'20px', fontSize:'12px', fontWeight:'500', cursor:'pointer', transition:'all 0.15s', fontFamily:"'Inter',system-ui,sans-serif", backgroundColor: selectedTags.includes(tag)?T.accent:T.white, color: selectedTags.includes(tag)?T.white:'#374151' }}>
                              {tag}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(320px,1fr))', gap:'20px' }}>
                      {filteredknowledgebase.map(item => (
                        <div key={item.id} className="dsr-card"
                          style={{ backgroundColor:T.white, borderRadius:'10px', padding:'20px', border:`1px solid #e5e7eb`, boxShadow:'0 1px 4px rgba(0,0,0,0.06)', transition:'all 0.15s', cursor:'pointer', position:'relative', overflow:'hidden' }}>
                          <div style={{ display:'flex', alignItems:'center', gap:'6px', marginBottom:'12px', fontSize:'11px', fontWeight:'700', textTransform:'uppercase', letterSpacing:'0.04em', color:getTypeColor(item.type) }}>
                            {getFileIcon(item.type)} {item.type}
                          </div>
                          <h3 style={{ fontSize:'15px', fontWeight:'700', color:T.textPrimary, marginBottom:'6px', margin:'0 0 6px 0', lineHeight:'1.3' }}>{item.title}</h3>
                          <p style={{ fontSize:'12px', color:T.textMuted, lineHeight:'1.5', margin:'0 0 12px 0' }}>{item.description}</p>
                          <div style={{ display:'flex', alignItems:'center', fontSize:'11px', color:T.textMuted, marginBottom:'12px', gap:'5px' }}>
                            <Calendar size={11} /> {item.dateAdded}
                          </div>
                          <div style={{ display:'flex', flexWrap:'wrap', gap:'4px', marginBottom:'14px' }}>
                            {item.tags.slice(0,3).map(tag => (
                              <span key={tag} style={{ padding:'2px 8px', backgroundColor:'#f3f4f6', color:T.textSecondary, borderRadius:'6px', fontSize:'11px', fontWeight:'500' }}>{tag}</span>
                            ))}
                          </div>
                          <div style={{ display:'flex', gap:'6px', paddingTop:'12px', borderTop:`1px solid #f1f5f9` }}>
                            <button onClick={(e) => { e.stopPropagation(); window.open('https://api.successguardian.in/media/'+item.url,'_blank'); }}
                              style={{ padding:'6px 10px', border:`1.5px solid ${T.borderMed}`, borderRadius:'7px', fontSize:'12px', fontWeight:'600', cursor:'pointer', backgroundColor:T.white, color:T.textSecondary, display:'flex', alignItems:'center', gap:'4px', transition:'all 0.15s', fontFamily:"'Inter',system-ui,sans-serif" }}
                              onMouseEnter={(e) => { e.currentTarget.style.borderColor=T.accent; e.currentTarget.style.color=T.accent; }}
                              onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.color=T.textSecondary; }}>
                              <Eye size={12} /> View
                            </button>
                            {item.type !== 'link' ? (
                              <button onClick={(e) => { e.stopPropagation(); downloadDocument(item.url); }}
                                style={{ padding:'6px 10px', border:`1.5px solid ${T.borderMed}`, borderRadius:'7px', fontSize:'12px', fontWeight:'600', cursor:'pointer', backgroundColor:T.white, color:T.textSecondary, display:'flex', alignItems:'center', gap:'4px', transition:'all 0.15s', fontFamily:"'Inter',system-ui,sans-serif" }}
                                onMouseEnter={(e) => { e.currentTarget.style.borderColor='#15803d'; e.currentTarget.style.color='#15803d'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.color=T.textSecondary; }}>
                                <Download size={12} /> Download
                              </button>
                            ) : (
                              <button onClick={(e) => { e.stopPropagation(); window.open(item.url,'_blank'); }}
                                style={{ padding:'6px 10px', border:`1.5px solid ${T.borderMed}`, borderRadius:'7px', fontSize:'12px', fontWeight:'600', cursor:'pointer', backgroundColor:T.white, color:T.textSecondary, display:'flex', alignItems:'center', gap:'4px', transition:'all 0.15s', fontFamily:"'Inter',system-ui,sans-serif" }}
                                onMouseEnter={(e) => { e.currentTarget.style.borderColor=T.accent; e.currentTarget.style.color=T.accent; }}
                                onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.color=T.textSecondary; }}>
                                <ExternalLink size={12} /> Open Link
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>

                    {filteredknowledgebase.length === 0 && (
                      <div style={{ textAlign:'center', padding:'56px 24px', animation:'fadeIn 0.4s ease' }}>
                        <div style={{ width:'56px', height:'56px', backgroundColor:'#e5e7eb', borderRadius:'12px', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px auto' }}>
                          <BringToFront size={24} color={T.textMuted} />
                        </div>
                        <p style={{ margin:'0 0 6px 0', fontSize:'15px', fontWeight:'700', color:T.textPrimary }}>No resources found</p>
                        <p style={{ margin:0, fontSize:'13px', color:T.textMuted }}>Upload your first resource to get started</p>
                      </div>
                    )}
                  </div>
                )}

              </div>
            </div>
          </div>

          {/* ── ALL MODALS (kept exactly as original logic, only CTA color updated) ── */}
          <AddTaskModal addtask={addtask} setaddtask={setaddtask} task_name={task_name} settask_name={settask_name} task_user={task_user} task_user_list={allusersnames} settask_user={settask_user} task_status={task_status} settask_status={settask_status} task_priority={task_priority} settask_priority={settask_priority} task_due_date={task_due_date} settask_due_date={settask_due_date} task_note={task_note} settask_note={settask_note} alladdtionalfields={alladdtionalfields.filter(addfieldx => addfieldx.selectedgroup === selectedGroupId || addfieldx.selectedgroup === 'all')} alladdtionalfieldsvalues={alladdtionalfieldsvalues} setalladdtionalfieldsvalues={setalladdtionalfieldsvalues} create_task={create_task} setloading={setloading} />
          <AddGroupModal addgroup={addgroup} setaddgroup={setaddgroup} group_name={group_name} setgroup_name={setgroup_name} create_group={create_group} setloading={setloading} />
          <UpdateGroupModal updategroup={updategroup} setupdategroup={setupdategroup} group_name={group_name} setgroup_name={setgroup_name} update_group={update_group} setloading={setloading} />
          <ShowShareModal shareshow={shareshow} setshareshow={setshareshow} shareusername={shareusername} setshareusername={setshareusername} shareemailid={shareemailid} setshareemailid={setshareemailid} shareuseraccess={shareuseraccess} setshareuseraccess={setshareuseraccess} setloading={setloading} grant_access={grant_access} ShareLink={ShareLink} />
          <ShowEditAccessModal showeditaccess={showeditaccess} setshoweditaccess={setshoweditaccess} shareusername={shareusername} setshareusername={setshareusername} shareemailid={shareemailid} setshareemailid={setshareemailid} shareuseraccess={shareuseraccess} setshareuseraccess={setshareuseraccess} setloading={setloading} edit_access={edit_access} />
          <UploadKnowledgebaseModal showkb={showkb} setshowkb={setshowkb} kbfilename={kbfilename} setkbfilename={setkbfilename} kbdescription={kbdescription} setkbdescription={setkbdescription} kbtags={kbtags} allavailabletags={allavailablekbtags} setkbtags={setkbtags} kburl={kburl} seturl={seturl} kbfileInputRef={kbfileInputRef} kbfiles={kbfiles} setkbfiles={setkbfiles} setloading={setloading} uploaddsrknowledgebaseresource={uploaddsrknowledgebaseresource} uploaddsrknowledgebaseresourcelink={uploaddsrknowledgebaseresourcelink} />

          <Modal className="default-template-modal" show={showsavetemplate} onHide={() => setshowsavetemplate(false)}>
            <Modal.Header><Modal.Title>Save as Template</Modal.Title></Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-4 form-group">
                  <input type="text" placeholder="Title" value={title} onChange={(e) => setTitle(e.target.value)} className="form-control" />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" style={{ border:'none', fontSize:'14px', background:T.accent, width:'100px', height:'40px', borderRadius:'25px', color:T.white, cursor:'pointer' }} onClick={saveastemplate}>Save</button>
              <button type="button" style={{ border:'none', fontSize:'14px', background:T.accent, width:'100px', height:'40px', borderRadius:'25px', color:T.white, cursor:'pointer' }} onClick={() => setshowsavetemplate(false)}>Close</button>
            </Modal.Footer>
          </Modal>

          <Modal className="default-template-modal" show={showoverridetemplate} onHide={() => setshowoverridetemplate(false)}>
            <Modal.Header><Modal.Title>Select Template to Override</Modal.Title></Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-4 form-group">
                  <select className="form-select-control" value={templateid} onChange={(e) => settemplateid(e.target.value)}>
                    <option value="">Select Template</option>
                    {Object.entries(alltemplates).map(([key, val]) => <option key={key} value={key}>{val}</option>)}
                  </select>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" style={{ border:'none', fontSize:'14px', background:T.accent, width:'100px', height:'40px', borderRadius:'25px', color:T.white, cursor:'pointer' }} onClick={overridewithtemplate}>Save</button>
              <button type="button" style={{ border:'none', fontSize:'14px', background:T.accent, width:'100px', height:'40px', borderRadius:'25px', color:T.white, cursor:'pointer' }} onClick={() => setshowoverridetemplate(false)}>Close</button>
            </Modal.Footer>
          </Modal>

          <Modal className="default-template-modal csvuploadmodal" show={showuploadcsvcsplan} onHide={() => setshowuploadcsvcsplan(false)}>
            <Modal.Header><Modal.Title style={{ marginLeft:'10px', marginTop:'10px' }}>SuccessPlan Via CSV Upload</Modal.Title></Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-4 form-group">
                  <input style={{ cursor:'pointer' }} type="file" onChange={handleFileChange} accept=".csv,.xls,.xlsx,.numbers" />
                  <div className="dsruploadcsv" style={{ width:'500px' }}>
                    {columnNames.length > 0 && (
                      <>
                        <h2 style={{ fontSize:'24px', borderBottom:`2px solid ${T.accent}`, marginTop:'10px', marginLeft:'-10px', marginBottom:'20px' }}>Map the columns</h2>
                        <ul style={{ width:'800px', marginLeft:'-50px', height:'300px', overflowY:'scroll', overflowX:'hidden' }}>
                          {columnNames.map((columnName) => (
                            <li key={columnName} style={{ width:'500px', display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 15px', margin:'10px 0', backgroundColor:T.white, border:`1px solid ${T.border}`, borderRadius:'8px', boxShadow:'0 2px 4px rgba(0,0,0,0.06)', listStyle:'none' }}>
                              <span style={{ fontSize:'14px', fontWeight:'500', color:T.textSecondary }}>{columnName} ➡️</span>
                              <select style={{ width:'250px', padding:'8px 10px', borderRadius:'6px', border:`1.5px solid ${T.borderMed}`, backgroundColor:'#f9fafb', color:T.textSecondary, fontSize:'14px', cursor:'pointer' }}
                                className="form-select" onChange={(e) => handleMappingChange(columnName, e.target.value)}>
                                <option value="">Select</option>
                                <option value="Objective">Objective</option>
                                <option value="title">Task Title</option>
                                <option value="description">Task Description</option>
                                {availablecolumns.map((col, idx) => <option key={idx} value={col.val}>{col.val}</option>)}
                              </select>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </div>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" onClick={handleFileSave} style={{ border:'none', background:T.accent, color:T.white, borderRadius:'20px', width:'130px', height:'43px', cursor:'pointer' }}>Save</button>
              <button type="button" style={{ border:'none', fontSize:'14px', background:T.accent, width:'100px', height:'40px', borderRadius:'25px', color:T.white, cursor:'pointer' }} onClick={() => setshowuploadcsvcsplan(false)}>Close</button>
            </Modal.Footer>
          </Modal>

          <AddKPIModal showaddkpi={ShowAddKPIForm} setshowaddkpi={setShowAddKPIForm} formData={formData} setFormData={setFormData} attributes={attributes} group_attributes={group_attributes} add_kpi={Add_KPI} setloading={setloading} />
          <EditKPIModal showeditkpi={ShowEditKPIForm} setshoweditkpi={setShowEditKPIForm} formData={formData} setFormData={setFormData} attributes={attributes} group_attributes={group_attributes} edit_kpi={Edit_KPI} setloading={setloading} />

          <Modal className="default-template-modal" show={showeditaddtionalfield} onHide={() => setshoweditaddtionalfield(false)}>
            <Modal.Header><Modal.Title>Edit Additional Field</Modal.Title></Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Label>Field Name</Form.Label>
                <Form.Group className="mb-4 form-group" style={{ marginTop:'10px', marginBottom:'20px' }}>
                  <input type="text" placeholder="Name" value={field_name} onChange={(e) => setfield_name(e.target.value)} className="form-control" />
                </Form.Group>
                <Form.Label>Field Type</Form.Label>
                <Form.Group className="mb-4 form-group" style={{ marginTop:'10px', marginBottom:'20px' }}>
                  <select className="form-select-control" value={field_type} onChange={(e) => setfield_type(e.target.value)}>
                    <option value="text">Text</option><option value="date">Date</option>
                    <option value="single choice">Single Choice</option><option value="multiple choice">Multiple Choice</option>
                  </select>
                </Form.Group>
                {(field_type==="single choice" || field_type==="multiple choice") && (
                  <>
                    <Form.Label style={{ marginTop:'10px' }}>Options</Form.Label>
                    <Form.Group className="mb-4 form-group" style={{ marginTop:'10px', marginBottom:'20px' }}>
                      <input type="text" placeholder="Enter MCQ Options separated by commas (,)" value={field_options} onChange={(e) => setfield_options(e.target.value)} className="form-control" />
                    </Form.Group>
                  </>
                )}
                <Form.Label>Which Group?</Form.Label>
                <Form.Group className="mb-4 form-group" style={{ marginTop:'10px', marginBottom:'20px' }}>
                  <select className="form-select-control" value={field_selected_group} onChange={(e) => setfield_selected_group(e.target.value)}>
                    <option value="all">All Groups</option>
                    {taskGroups.map(group => <option key={group.id} value={group.id}>{group.title}</option>)}
                  </select>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" style={{ border:'none', fontSize:'14px', background:T.accent, width:'100px', height:'40px', borderRadius:'25px', color:T.white, cursor:'pointer' }} onClick={update_addtionalfield}>Update</button>
              <button type="button" style={{ border:'none', fontSize:'14px', background:T.accent, width:'100px', height:'40px', borderRadius:'25px', color:T.white, cursor:'pointer' }} onClick={() => setshoweditaddtionalfield(false)}>Close</button>
            </Modal.Footer>
          </Modal>

          <Modal className="default-template-modal" show={showeaddddtionalfield} onHide={() => setshowaddaddtionalfield(false)}>
            <Modal.Header><Modal.Title>Add Additional Field</Modal.Title></Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Label>Field Name</Form.Label>
                <Form.Group className="mb-4 form-group" style={{ marginTop:'10px', marginBottom:'20px' }}>
                  <input type="text" placeholder="Name" value={field_name} onChange={(e) => setfield_name(e.target.value)} className="form-control" />
                </Form.Group>
                <Form.Label>Field Type</Form.Label>
                <Form.Group className="mb-4 form-group" style={{ marginTop:'10px', marginBottom:'20px' }}>
                  <select className="form-select-control" value={field_type} onChange={(e) => setfield_type(e.target.value)}>
                    <option value="text">Text</option><option value="date">Date</option>
                    <option value="single choice">Single Choice</option><option value="multiple choice">Multiple Choice</option>
                  </select>
                </Form.Group>
                {(field_type==="single choice" || field_type==="multiple choice") && (
                  <>
                    <Form.Label style={{ marginTop:'10px' }}>Options</Form.Label>
                    <Form.Group className="mb-4 form-group" style={{ marginTop:'10px', marginBottom:'20px' }}>
                      <input type="text" placeholder="Enter MCQ Options separated by commas (,)" value={field_options} onChange={(e) => setfield_options(e.target.value)} className="form-control" />
                    </Form.Group>
                  </>
                )}
                <Form.Label>Which Group?</Form.Label>
                <Form.Group className="mb-4 form-group" style={{ marginTop:'10px', marginBottom:'20px' }}>
                  <select className="form-select-control" value={field_selected_group} onChange={(e) => setfield_selected_group(e.target.value)}>
                    <option value="all">All Groups</option>
                    {taskGroups.map(group => <option key={group.id} value={group.id}>{group.title}</option>)}
                  </select>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" style={{ border:'none', fontSize:'14px', background:T.accent, width:'100px', height:'40px', borderRadius:'25px', color:T.white, cursor:'pointer' }} onClick={add_addtionalfield}>Save</button>
              <button type="button" style={{ border:'none', fontSize:'14px', background:T.accent, width:'100px', height:'40px', borderRadius:'25px', color:T.white, cursor:'pointer' }} onClick={() => setshowaddaddtionalfield(false)}>Close</button>
            </Modal.Footer>
          </Modal>

        </div>
      </SkeletonWrapper>
    </>
  );
};

export default DigitalSuccessRoom;